/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkforceRouteImport } from './routes/workforce'
import { Route as TimeRouteImport } from './routes/time'
import { Route as RiskRouteImport } from './routes/risk'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as RelationshipsRouteImport } from './routes/relationships'
import { Route as ProvidersRouteImport } from './routes/providers'
import { Route as ProposalsRouteImport } from './routes/proposals'
import { Route as OrgChartRouteImport } from './routes/org-chart'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as ImportCenterRouteImport } from './routes/import-center'
import { Route as EntitiesRouteImport } from './routes/entities'
import { Route as EngagementsRouteImport } from './routes/engagements'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as BrowserLiveRouteImport } from './routes/browser-live'
import { Route as AgentRouteImport } from './routes/agent'
import { Route as AgenciesRouteImport } from './routes/agencies'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkforceIndexRouteImport } from './routes/workforce/index'
import { Route as TimeIndexRouteImport } from './routes/time/index'
import { Route as TemplateEngineIndexRouteImport } from './routes/template-engine/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ProvidersIndexRouteImport } from './routes/providers/index'
import { Route as ProposalsIndexRouteImport } from './routes/proposals/index'
import { Route as PeopleIndexRouteImport } from './routes/people/index'
import { Route as InvoicesIndexRouteImport } from './routes/invoices/index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations/index'
import { Route as HelpRequestsIndexRouteImport } from './routes/help-requests/index'
import { Route as FormsIndexRouteImport } from './routes/forms/index'
import { Route as FavouritesIndexRouteImport } from './routes/favourites/index'
import { Route as EntitiesIndexRouteImport } from './routes/entities/index'
import { Route as EngagementsIndexRouteImport } from './routes/engagements/index'
import { Route as DocumentsIndexRouteImport } from './routes/documents/index'
import { Route as CrmIndexRouteImport } from './routes/crm/index'
import { Route as ComplianceIndexRouteImport } from './routes/compliance/index'
import { Route as ClientsIndexRouteImport } from './routes/clients/index'
import { Route as AskIndexRouteImport } from './routes/ask/index'
import { Route as AgenciesIndexRouteImport } from './routes/agencies/index'
import { Route as WorkforceWorkerIdRouteImport } from './routes/workforce/$workerId'
import { Route as TimeWorkforcePlanRouteImport } from './routes/time/workforce-plan'
import { Route as TimeSubmissionsRouteImport } from './routes/time/submissions'
import { Route as TimePoliciesRouteImport } from './routes/time/policies'
import { Route as TimeOffRouteImport } from './routes/time/off'
import { Route as TimeMyTimeRouteImport } from './routes/time/my-time'
import { Route as TimeMySetupRouteImport } from './routes/time/my-setup'
import { Route as TimeLogsRouteImport } from './routes/time/logs'
import { Route as TimeHolidaysRouteImport } from './routes/time/holidays'
import { Route as TimeCyclesRouteImport } from './routes/time/cycles'
import { Route as TimeAvailabilityRouteImport } from './routes/time/availability'
import { Route as TimeAttendanceRouteImport } from './routes/time/attendance'
import { Route as SettingsInviteMemberRouteImport } from './routes/settings/invite-member'
import { Route as SettingsBrandingRouteImport } from './routes/settings/branding'
import { Route as ProvidersVendorIdRouteImport } from './routes/providers/$vendorId'
import { Route as ProposalsNewRouteImport } from './routes/proposals/new'
import { Route as ProposalsApprovalsRouteImport } from './routes/proposals/approvals'
import { Route as ProposalsProposalIdRouteImport } from './routes/proposals/$proposalId'
import { Route as PeopleNewRouteImport } from './routes/people/new'
import { Route as PeoplePersonIdRouteImport } from './routes/people/$personId'
import { Route as OwnershipStructureRouteImport } from './routes/ownership/structure'
import { Route as OnboardingWorkerRouteImport } from './routes/onboarding.worker'
import { Route as OnboardingVendorRouteImport } from './routes/onboarding.vendor'
import { Route as OnboardingEorAorRouteImport } from './routes/onboarding.eor-aor'
import { Route as OnboardingClientRouteImport } from './routes/onboarding.client'
import { Route as OnboardingAgencyRouteImport } from './routes/onboarding.agency'
import { Route as OauthCallbackRouteImport } from './routes/oauth.callback'
import { Route as InvoicesTaxRulesRouteImport } from './routes/invoices/tax-rules'
import { Route as InvoicesServiceCatalogueRouteImport } from './routes/invoices/service-catalogue'
import { Route as InvoicesNewRouteImport } from './routes/invoices/new'
import { Route as InvoicesDuesRouteImport } from './routes/invoices/dues'
import { Route as InvoicesCustomFieldsRouteImport } from './routes/invoices/custom-fields'
import { Route as InvoicesCategoriesRouteImport } from './routes/invoices/categories'
import { Route as InvoicesInvoiceIdRouteImport } from './routes/invoices/$invoiceId'
import { Route as IntegrationsBooksRouteImport } from './routes/integrations/books'
import { Route as FormsLibraryRouteImport } from './routes/forms/library'
import { Route as FormsAdminRouteImport } from './routes/forms/admin'
import { Route as EntitiesNewRouteImport } from './routes/entities/new'
import { Route as EntitiesBulkImportRouteImport } from './routes/entities/bulk-import'
import { Route as EntitiesEntityIdRouteImport } from './routes/entities/$entityId'
import { Route as EngagementsNewRouteImport } from './routes/engagements/new'
import { Route as EngagementsEngagementIdRouteImport } from './routes/engagements/$engagementId'
import { Route as DocumentsUploadedRouteImport } from './routes/documents/uploaded'
import { Route as DocumentsInstanceIdRouteImport } from './routes/documents/$instanceId'
import { Route as CrmSettingsRouteImport } from './routes/crm/settings'
import { Route as CrmProposalsRouteImport } from './routes/crm/proposals'
import { Route as CrmOpportunitiesRouteImport } from './routes/crm/opportunities'
import { Route as CrmMyWorkRouteImport } from './routes/crm/my-work'
import { Route as CrmLeadsRouteImport } from './routes/crm/leads'
import { Route as CrmHandoverRouteImport } from './routes/crm/handover'
import { Route as CrmContactsRouteImport } from './routes/crm/contacts'
import { Route as CrmCatalogRouteImport } from './routes/crm/catalog'
import { Route as ComplianceCalendarRouteImport } from './routes/compliance/calendar'
import { Route as ClientsClientIdRouteImport } from './routes/clients/$clientId'
import { Route as AskConversationIdRouteImport } from './routes/ask/$conversationId'
import { Route as AgreementsAgreementIdRouteImport } from './routes/agreements/$agreementId'
import { Route as AgentSessionIdRouteImport } from './routes/agent.$sessionId'
import { Route as AgencyPendingRouteImport } from './routes/agency/pending'
import { Route as AgenciesAgencyIdRouteImport } from './routes/agencies/$agencyId'
import { Route as TimeOffIndexRouteImport } from './routes/time/off/index'
import { Route as TimeLogsIndexRouteImport } from './routes/time/logs/index'
import { Route as TemplateEngineTemplatesIndexRouteImport } from './routes/template-engine/templates/index'
import { Route as PlatformAgenciesIndexRouteImport } from './routes/platform/agencies/index'
import { Route as FormsTemplatesIndexRouteImport } from './routes/forms/templates/index'
import { Route as CrmProposalsIndexRouteImport } from './routes/crm/proposals/index'
import { Route as AskCanvasIndexRouteImport } from './routes/ask/canvas/index'
import { Route as TimeLogsTimesheetIdRouteImport } from './routes/time/logs/$timesheetId'
import { Route as TemplateEngineTemplatesNewRouteImport } from './routes/template-engine/templates/new'
import { Route as TemplateEngineTemplatesTemplateIdRouteImport } from './routes/template-engine/templates/$templateId'
import { Route as ProposalsProposalIdReviewRouteImport } from './routes/proposals/$proposalId_.review'
import { Route as ProposalsProposalIdEditRouteImport } from './routes/proposals/$proposalId_.edit'
import { Route as IntegrationsProvidersProviderIdRouteImport } from './routes/integrations/providers.$providerId'
import { Route as IntegrationsConnectionsIdRouteImport } from './routes/integrations/connections.$id'
import { Route as FormsTemplatesNewRouteImport } from './routes/forms/templates/new'
import { Route as FormsTemplatesTemplateIdRouteImport } from './routes/forms/templates/$templateId'
import { Route as FormsAdminNewRouteImport } from './routes/forms/admin/new'
import { Route as EngagementsEngagementIdIntakeRouteImport } from './routes/engagements/$engagementId_.intake'
import { Route as DocumentsUploadedDocumentIdRouteImport } from './routes/documents/uploaded/$documentId'
import { Route as CrmProposalsNewRouteImport } from './routes/crm/proposals/new'
import { Route as CrmProposalsApprovalsRouteImport } from './routes/crm/proposals/approvals'
import { Route as CrmProposalsProposalIdRouteImport } from './routes/crm/proposals/$proposalId'
import { Route as IntegrationsProvidersProviderIdDiscoveryRouteImport } from './routes/integrations/providers.$providerId.discovery'
import { Route as IntegrationsConnectionsIdMappingsRouteImport } from './routes/integrations/connections.$id.mappings'
import { Route as CrmProposalsProposalIdReviewRouteImport } from './routes/crm/proposals/$proposalId_.review'
import { Route as CrmProposalsProposalIdEditRouteImport } from './routes/crm/proposals/$proposalId_.edit'

const BrowserLiveSessionIdLazyRouteImport = createFileRoute(
  '/browser-live/$sessionId',
)()

const WorkforceRoute = WorkforceRouteImport.update({
  id: '/workforce',
  path: '/workforce',
  getParentRoute: () => rootRouteImport,
} as any)
const TimeRoute = TimeRouteImport.update({
  id: '/time',
  path: '/time',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskRoute = RiskRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/risk.lazy').then((d) => d.Route))
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/reports.lazy').then((d) => d.Route))
const RelationshipsRoute = RelationshipsRouteImport.update({
  id: '/relationships',
  path: '/relationships',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/relationships.lazy').then((d) => d.Route))
const ProvidersRoute = ProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalsRoute = ProposalsRouteImport.update({
  id: '/proposals',
  path: '/proposals',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgChartRoute = OrgChartRouteImport.update({
  id: '/org-chart',
  path: '/org-chart',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/org-chart.lazy').then((d) => d.Route))
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/integrations.lazy').then((d) => d.Route))
const ImportCenterRoute = ImportCenterRouteImport.update({
  id: '/import-center',
  path: '/import-center',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/import-center.lazy').then((d) => d.Route))
const EntitiesRoute = EntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => rootRouteImport,
} as any)
const EngagementsRoute = EngagementsRouteImport.update({
  id: '/engagements',
  path: '/engagements',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/dashboard.lazy').then((d) => d.Route))
const CrmRoute = CrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/calendar.lazy').then((d) => d.Route))
const BrowserLiveRoute = BrowserLiveRouteImport.update({
  id: '/browser-live',
  path: '/browser-live',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRoute = AgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/agent.lazy').then((d) => d.Route))
const AgenciesRoute = AgenciesRouteImport.update({
  id: '/agencies',
  path: '/agencies',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const WorkforceIndexRoute = WorkforceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkforceRoute,
} as any).lazy(() =>
  import('./routes/workforce/index.lazy').then((d) => d.Route),
)
const TimeIndexRoute = TimeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TimeRoute,
} as any).lazy(() => import('./routes/time/index.lazy').then((d) => d.Route))
const TemplateEngineIndexRoute = TemplateEngineIndexRouteImport.update({
  id: '/template-engine/',
  path: '/template-engine/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/index.lazy').then((d) => d.Route),
)
const ProvidersIndexRoute = ProvidersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProvidersRoute,
} as any).lazy(() =>
  import('./routes/providers/index.lazy').then((d) => d.Route),
)
const ProposalsIndexRoute = ProposalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProposalsRoute,
} as any).lazy(() =>
  import('./routes/proposals/index.lazy').then((d) => d.Route),
)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/people/index.lazy').then((d) => d.Route))
const InvoicesIndexRoute = InvoicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InvoicesRoute,
} as any).lazy(() =>
  import('./routes/invoices/index.lazy').then((d) => d.Route),
)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IntegrationsRoute,
} as any).lazy(() =>
  import('./routes/integrations/index.lazy').then((d) => d.Route),
)
const HelpRequestsIndexRoute = HelpRequestsIndexRouteImport.update({
  id: '/help-requests/',
  path: '/help-requests/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/help-requests/index.lazy').then((d) => d.Route),
)
const FormsIndexRoute = FormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => rootRouteImport,
} as any)
const FavouritesIndexRoute = FavouritesIndexRouteImport.update({
  id: '/favourites/',
  path: '/favourites/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/favourites/index.lazy').then((d) => d.Route),
)
const EntitiesIndexRoute = EntitiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EntitiesRoute,
} as any).lazy(() =>
  import('./routes/entities/index.lazy').then((d) => d.Route),
)
const EngagementsIndexRoute = EngagementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EngagementsRoute,
} as any).lazy(() =>
  import('./routes/engagements/index.lazy').then((d) => d.Route),
)
const DocumentsIndexRoute = DocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocumentsRoute,
} as any).lazy(() =>
  import('./routes/documents/index.lazy').then((d) => d.Route),
)
const CrmIndexRoute = CrmIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CrmRoute,
} as any)
const ComplianceIndexRoute = ComplianceIndexRouteImport.update({
  id: '/compliance/',
  path: '/compliance/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compliance/index.lazy').then((d) => d.Route),
)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientsRoute,
} as any).lazy(() => import('./routes/clients/index.lazy').then((d) => d.Route))
const AskIndexRoute = AskIndexRouteImport.update({
  id: '/ask/',
  path: '/ask/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgenciesIndexRoute = AgenciesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgenciesRoute,
} as any).lazy(() =>
  import('./routes/agencies/index.lazy').then((d) => d.Route),
)
const BrowserLiveSessionIdLazyRoute =
  BrowserLiveSessionIdLazyRouteImport.update({
    id: '/$sessionId',
    path: '/$sessionId',
    getParentRoute: () => BrowserLiveRoute,
  } as any).lazy(() =>
    import('./routes/browser-live/$sessionId.lazy').then((d) => d.Route),
  )
const WorkforceWorkerIdRoute = WorkforceWorkerIdRouteImport.update({
  id: '/$workerId',
  path: '/$workerId',
  getParentRoute: () => WorkforceRoute,
} as any).lazy(() =>
  import('./routes/workforce/$workerId.lazy').then((d) => d.Route),
)
const TimeWorkforcePlanRoute = TimeWorkforcePlanRouteImport.update({
  id: '/workforce-plan',
  path: '/workforce-plan',
  getParentRoute: () => TimeRoute,
} as any).lazy(() =>
  import('./routes/time/workforce-plan.lazy').then((d) => d.Route),
)
const TimeSubmissionsRoute = TimeSubmissionsRouteImport.update({
  id: '/submissions',
  path: '/submissions',
  getParentRoute: () => TimeRoute,
} as any).lazy(() =>
  import('./routes/time/submissions.lazy').then((d) => d.Route),
)
const TimePoliciesRoute = TimePoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => TimeRoute,
} as any).lazy(() => import('./routes/time/policies.lazy').then((d) => d.Route))
const TimeOffRoute = TimeOffRouteImport.update({
  id: '/off',
  path: '/off',
  getParentRoute: () => TimeRoute,
} as any)
const TimeMyTimeRoute = TimeMyTimeRouteImport.update({
  id: '/my-time',
  path: '/my-time',
  getParentRoute: () => TimeRoute,
} as any).lazy(() => import('./routes/time/my-time.lazy').then((d) => d.Route))
const TimeMySetupRoute = TimeMySetupRouteImport.update({
  id: '/my-setup',
  path: '/my-setup',
  getParentRoute: () => TimeRoute,
} as any).lazy(() => import('./routes/time/my-setup.lazy').then((d) => d.Route))
const TimeLogsRoute = TimeLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => TimeRoute,
} as any)
const TimeHolidaysRoute = TimeHolidaysRouteImport.update({
  id: '/holidays',
  path: '/holidays',
  getParentRoute: () => TimeRoute,
} as any).lazy(() => import('./routes/time/holidays.lazy').then((d) => d.Route))
const TimeCyclesRoute = TimeCyclesRouteImport.update({
  id: '/cycles',
  path: '/cycles',
  getParentRoute: () => TimeRoute,
} as any).lazy(() => import('./routes/time/cycles.lazy').then((d) => d.Route))
const TimeAvailabilityRoute = TimeAvailabilityRouteImport.update({
  id: '/availability',
  path: '/availability',
  getParentRoute: () => TimeRoute,
} as any).lazy(() =>
  import('./routes/time/availability.lazy').then((d) => d.Route),
)
const TimeAttendanceRoute = TimeAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => TimeRoute,
} as any).lazy(() =>
  import('./routes/time/attendance.lazy').then((d) => d.Route),
)
const SettingsInviteMemberRoute = SettingsInviteMemberRouteImport.update({
  id: '/settings/invite-member',
  path: '/settings/invite-member',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/invite-member.lazy').then((d) => d.Route),
)
const SettingsBrandingRoute = SettingsBrandingRouteImport.update({
  id: '/settings/branding',
  path: '/settings/branding',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/branding.lazy').then((d) => d.Route),
)
const ProvidersVendorIdRoute = ProvidersVendorIdRouteImport.update({
  id: '/$vendorId',
  path: '/$vendorId',
  getParentRoute: () => ProvidersRoute,
} as any).lazy(() =>
  import('./routes/providers/$vendorId.lazy').then((d) => d.Route),
)
const ProposalsNewRoute = ProposalsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ProposalsRoute,
} as any).lazy(() => import('./routes/proposals/new.lazy').then((d) => d.Route))
const ProposalsApprovalsRoute = ProposalsApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => ProposalsRoute,
} as any).lazy(() =>
  import('./routes/proposals/approvals.lazy').then((d) => d.Route),
)
const ProposalsProposalIdRoute = ProposalsProposalIdRouteImport.update({
  id: '/$proposalId',
  path: '/$proposalId',
  getParentRoute: () => ProposalsRoute,
} as any).lazy(() =>
  import('./routes/proposals/$proposalId.lazy').then((d) => d.Route),
)
const PeopleNewRoute = PeopleNewRouteImport.update({
  id: '/people/new',
  path: '/people/new',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/people/new.lazy').then((d) => d.Route))
const PeoplePersonIdRoute = PeoplePersonIdRouteImport.update({
  id: '/people/$personId',
  path: '/people/$personId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/people/$personId.lazy').then((d) => d.Route),
)
const OwnershipStructureRoute = OwnershipStructureRouteImport.update({
  id: '/ownership/structure',
  path: '/ownership/structure',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/ownership/structure.lazy').then((d) => d.Route),
)
const OnboardingWorkerRoute = OnboardingWorkerRouteImport.update({
  id: '/onboarding/worker',
  path: '/onboarding/worker',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onboarding.worker.lazy').then((d) => d.Route),
)
const OnboardingVendorRoute = OnboardingVendorRouteImport.update({
  id: '/onboarding/vendor',
  path: '/onboarding/vendor',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onboarding.vendor.lazy').then((d) => d.Route),
)
const OnboardingEorAorRoute = OnboardingEorAorRouteImport.update({
  id: '/onboarding/eor-aor',
  path: '/onboarding/eor-aor',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onboarding.eor-aor.lazy').then((d) => d.Route),
)
const OnboardingClientRoute = OnboardingClientRouteImport.update({
  id: '/onboarding/client',
  path: '/onboarding/client',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onboarding.client.lazy').then((d) => d.Route),
)
const OnboardingAgencyRoute = OnboardingAgencyRouteImport.update({
  id: '/onboarding/agency',
  path: '/onboarding/agency',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/onboarding.agency.lazy').then((d) => d.Route),
)
const OauthCallbackRoute = OauthCallbackRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/oauth.callback.lazy').then((d) => d.Route),
)
const InvoicesTaxRulesRoute = InvoicesTaxRulesRouteImport.update({
  id: '/tax-rules',
  path: '/tax-rules',
  getParentRoute: () => InvoicesRoute,
} as any).lazy(() =>
  import('./routes/invoices/tax-rules.lazy').then((d) => d.Route),
)
const InvoicesServiceCatalogueRoute =
  InvoicesServiceCatalogueRouteImport.update({
    id: '/service-catalogue',
    path: '/service-catalogue',
    getParentRoute: () => InvoicesRoute,
  } as any).lazy(() =>
    import('./routes/invoices/service-catalogue.lazy').then((d) => d.Route),
  )
const InvoicesNewRoute = InvoicesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => InvoicesRoute,
} as any).lazy(() => import('./routes/invoices/new.lazy').then((d) => d.Route))
const InvoicesDuesRoute = InvoicesDuesRouteImport.update({
  id: '/dues',
  path: '/dues',
  getParentRoute: () => InvoicesRoute,
} as any).lazy(() => import('./routes/invoices/dues.lazy').then((d) => d.Route))
const InvoicesCustomFieldsRoute = InvoicesCustomFieldsRouteImport.update({
  id: '/custom-fields',
  path: '/custom-fields',
  getParentRoute: () => InvoicesRoute,
} as any).lazy(() =>
  import('./routes/invoices/custom-fields.lazy').then((d) => d.Route),
)
const InvoicesCategoriesRoute = InvoicesCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => InvoicesRoute,
} as any).lazy(() =>
  import('./routes/invoices/categories.lazy').then((d) => d.Route),
)
const InvoicesInvoiceIdRoute = InvoicesInvoiceIdRouteImport.update({
  id: '/$invoiceId',
  path: '/$invoiceId',
  getParentRoute: () => InvoicesRoute,
} as any).lazy(() =>
  import('./routes/invoices/$invoiceId.lazy').then((d) => d.Route),
)
const IntegrationsBooksRoute = IntegrationsBooksRouteImport.update({
  id: '/books',
  path: '/books',
  getParentRoute: () => IntegrationsRoute,
} as any).lazy(() =>
  import('./routes/integrations/books.lazy').then((d) => d.Route),
)
const FormsLibraryRoute = FormsLibraryRouteImport.update({
  id: '/forms/library',
  path: '/forms/library',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/forms/library.lazy').then((d) => d.Route))
const FormsAdminRoute = FormsAdminRouteImport.update({
  id: '/forms/admin',
  path: '/forms/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/forms/admin.lazy').then((d) => d.Route))
const EntitiesNewRoute = EntitiesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => EntitiesRoute,
} as any).lazy(() => import('./routes/entities/new.lazy').then((d) => d.Route))
const EntitiesBulkImportRoute = EntitiesBulkImportRouteImport.update({
  id: '/bulk-import',
  path: '/bulk-import',
  getParentRoute: () => EntitiesRoute,
} as any).lazy(() =>
  import('./routes/entities/bulk-import.lazy').then((d) => d.Route),
)
const EntitiesEntityIdRoute = EntitiesEntityIdRouteImport.update({
  id: '/$entityId',
  path: '/$entityId',
  getParentRoute: () => EntitiesRoute,
} as any).lazy(() =>
  import('./routes/entities/$entityId.lazy').then((d) => d.Route),
)
const EngagementsNewRoute = EngagementsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => EngagementsRoute,
} as any).lazy(() =>
  import('./routes/engagements/new.lazy').then((d) => d.Route),
)
const EngagementsEngagementIdRoute = EngagementsEngagementIdRouteImport.update({
  id: '/$engagementId',
  path: '/$engagementId',
  getParentRoute: () => EngagementsRoute,
} as any).lazy(() =>
  import('./routes/engagements/$engagementId.lazy').then((d) => d.Route),
)
const DocumentsUploadedRoute = DocumentsUploadedRouteImport.update({
  id: '/uploaded',
  path: '/uploaded',
  getParentRoute: () => DocumentsRoute,
} as any)
const DocumentsInstanceIdRoute = DocumentsInstanceIdRouteImport.update({
  id: '/$instanceId',
  path: '/$instanceId',
  getParentRoute: () => DocumentsRoute,
} as any).lazy(() =>
  import('./routes/documents/$instanceId.lazy').then((d) => d.Route),
)
const CrmSettingsRoute = CrmSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => CrmRoute,
} as any)
const CrmProposalsRoute = CrmProposalsRouteImport.update({
  id: '/proposals',
  path: '/proposals',
  getParentRoute: () => CrmRoute,
} as any)
const CrmOpportunitiesRoute = CrmOpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => CrmRoute,
} as any)
const CrmMyWorkRoute = CrmMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => CrmRoute,
} as any)
const CrmLeadsRoute = CrmLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => CrmRoute,
} as any)
const CrmHandoverRoute = CrmHandoverRouteImport.update({
  id: '/handover',
  path: '/handover',
  getParentRoute: () => CrmRoute,
} as any)
const CrmContactsRoute = CrmContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => CrmRoute,
} as any)
const CrmCatalogRoute = CrmCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => CrmRoute,
} as any)
const ComplianceCalendarRoute = ComplianceCalendarRouteImport.update({
  id: '/compliance/calendar',
  path: '/compliance/calendar',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compliance/calendar.lazy').then((d) => d.Route),
)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => ClientsRoute,
} as any).lazy(() =>
  import('./routes/clients/$clientId.lazy').then((d) => d.Route),
)
const AskConversationIdRoute = AskConversationIdRouteImport.update({
  id: '/ask/$conversationId',
  path: '/ask/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AgreementsAgreementIdRoute = AgreementsAgreementIdRouteImport.update({
  id: '/agreements/$agreementId',
  path: '/agreements/$agreementId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/agreements/$agreementId.lazy').then((d) => d.Route),
)
const AgentSessionIdRoute = AgentSessionIdRouteImport.update({
  id: '/$sessionId',
  path: '/$sessionId',
  getParentRoute: () => AgentRoute,
} as any).lazy(() =>
  import('./routes/agent.$sessionId.lazy').then((d) => d.Route),
)
const AgencyPendingRoute = AgencyPendingRouteImport.update({
  id: '/agency/pending',
  path: '/agency/pending',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/agency/pending.lazy').then((d) => d.Route),
)
const AgenciesAgencyIdRoute = AgenciesAgencyIdRouteImport.update({
  id: '/$agencyId',
  path: '/$agencyId',
  getParentRoute: () => AgenciesRoute,
} as any).lazy(() =>
  import('./routes/agencies/$agencyId.lazy').then((d) => d.Route),
)
const TimeOffIndexRoute = TimeOffIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TimeOffRoute,
} as any).lazy(() =>
  import('./routes/time/off/index.lazy').then((d) => d.Route),
)
const TimeLogsIndexRoute = TimeLogsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TimeLogsRoute,
} as any)
const TemplateEngineTemplatesIndexRoute =
  TemplateEngineTemplatesIndexRouteImport.update({
    id: '/template-engine/templates/',
    path: '/template-engine/templates/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/template-engine/templates/index.lazy').then(
      (d) => d.Route,
    ),
  )
const PlatformAgenciesIndexRoute = PlatformAgenciesIndexRouteImport.update({
  id: '/platform/agencies/',
  path: '/platform/agencies/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/platform/agencies/index.lazy').then((d) => d.Route),
)
const FormsTemplatesIndexRoute = FormsTemplatesIndexRouteImport.update({
  id: '/forms/templates/',
  path: '/forms/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmProposalsIndexRoute = CrmProposalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CrmProposalsRoute,
} as any).lazy(() =>
  import('./routes/crm/proposals/index.lazy').then((d) => d.Route),
)
const AskCanvasIndexRoute = AskCanvasIndexRouteImport.update({
  id: '/ask/canvas/',
  path: '/ask/canvas/',
  getParentRoute: () => rootRouteImport,
} as any)
const TimeLogsTimesheetIdRoute = TimeLogsTimesheetIdRouteImport.update({
  id: '/$timesheetId',
  path: '/$timesheetId',
  getParentRoute: () => TimeLogsRoute,
} as any).lazy(() =>
  import('./routes/time/logs/$timesheetId.lazy').then((d) => d.Route),
)
const TemplateEngineTemplatesNewRoute =
  TemplateEngineTemplatesNewRouteImport.update({
    id: '/template-engine/templates/new',
    path: '/template-engine/templates/new',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/template-engine/templates/new.lazy').then((d) => d.Route),
  )
const TemplateEngineTemplatesTemplateIdRoute =
  TemplateEngineTemplatesTemplateIdRouteImport.update({
    id: '/template-engine/templates/$templateId',
    path: '/template-engine/templates/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/template-engine/templates/$templateId.lazy').then(
      (d) => d.Route,
    ),
  )
const ProposalsProposalIdReviewRoute =
  ProposalsProposalIdReviewRouteImport.update({
    id: '/$proposalId_/review',
    path: '/$proposalId/review',
    getParentRoute: () => ProposalsRoute,
  } as any).lazy(() =>
    import('./routes/proposals/$proposalId_.review.lazy').then((d) => d.Route),
  )
const ProposalsProposalIdEditRoute = ProposalsProposalIdEditRouteImport.update({
  id: '/$proposalId_/edit',
  path: '/$proposalId/edit',
  getParentRoute: () => ProposalsRoute,
} as any).lazy(() =>
  import('./routes/proposals/$proposalId_.edit.lazy').then((d) => d.Route),
)
const IntegrationsProvidersProviderIdRoute =
  IntegrationsProvidersProviderIdRouteImport.update({
    id: '/providers/$providerId',
    path: '/providers/$providerId',
    getParentRoute: () => IntegrationsRoute,
  } as any).lazy(() =>
    import('./routes/integrations/providers.$providerId.lazy').then(
      (d) => d.Route,
    ),
  )
const IntegrationsConnectionsIdRoute =
  IntegrationsConnectionsIdRouteImport.update({
    id: '/connections/$id',
    path: '/connections/$id',
    getParentRoute: () => IntegrationsRoute,
  } as any).lazy(() =>
    import('./routes/integrations/connections.$id.lazy').then((d) => d.Route),
  )
const FormsTemplatesNewRoute = FormsTemplatesNewRouteImport.update({
  id: '/forms/templates/new',
  path: '/forms/templates/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FormsTemplatesTemplateIdRoute =
  FormsTemplatesTemplateIdRouteImport.update({
    id: '/forms/templates/$templateId',
    path: '/forms/templates/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormsAdminNewRoute = FormsAdminNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => FormsAdminRoute,
} as any).lazy(() =>
  import('./routes/forms/admin/new.lazy').then((d) => d.Route),
)
const EngagementsEngagementIdIntakeRoute =
  EngagementsEngagementIdIntakeRouteImport.update({
    id: '/$engagementId_/intake',
    path: '/$engagementId/intake',
    getParentRoute: () => EngagementsRoute,
  } as any).lazy(() =>
    import('./routes/engagements/$engagementId_.intake.lazy').then(
      (d) => d.Route,
    ),
  )
const DocumentsUploadedDocumentIdRoute =
  DocumentsUploadedDocumentIdRouteImport.update({
    id: '/$documentId',
    path: '/$documentId',
    getParentRoute: () => DocumentsUploadedRoute,
  } as any).lazy(() =>
    import('./routes/documents/uploaded/$documentId.lazy').then((d) => d.Route),
  )
const CrmProposalsNewRoute = CrmProposalsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CrmProposalsRoute,
} as any).lazy(() =>
  import('./routes/crm/proposals/new.lazy').then((d) => d.Route),
)
const CrmProposalsApprovalsRoute = CrmProposalsApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => CrmProposalsRoute,
} as any).lazy(() =>
  import('./routes/crm/proposals/approvals.lazy').then((d) => d.Route),
)
const CrmProposalsProposalIdRoute = CrmProposalsProposalIdRouteImport.update({
  id: '/$proposalId',
  path: '/$proposalId',
  getParentRoute: () => CrmProposalsRoute,
} as any).lazy(() =>
  import('./routes/crm/proposals/$proposalId.lazy').then((d) => d.Route),
)
const IntegrationsProvidersProviderIdDiscoveryRoute =
  IntegrationsProvidersProviderIdDiscoveryRouteImport.update({
    id: '/discovery',
    path: '/discovery',
    getParentRoute: () => IntegrationsProvidersProviderIdRoute,
  } as any).lazy(() =>
    import('./routes/integrations/providers.$providerId.discovery.lazy').then(
      (d) => d.Route,
    ),
  )
const IntegrationsConnectionsIdMappingsRoute =
  IntegrationsConnectionsIdMappingsRouteImport.update({
    id: '/mappings',
    path: '/mappings',
    getParentRoute: () => IntegrationsConnectionsIdRoute,
  } as any).lazy(() =>
    import('./routes/integrations/connections.$id.mappings.lazy').then(
      (d) => d.Route,
    ),
  )
const CrmProposalsProposalIdReviewRoute =
  CrmProposalsProposalIdReviewRouteImport.update({
    id: '/$proposalId_/review',
    path: '/$proposalId/review',
    getParentRoute: () => CrmProposalsRoute,
  } as any).lazy(() =>
    import('./routes/crm/proposals/$proposalId_.review.lazy').then(
      (d) => d.Route,
    ),
  )
const CrmProposalsProposalIdEditRoute =
  CrmProposalsProposalIdEditRouteImport.update({
    id: '/$proposalId_/edit',
    path: '/$proposalId/edit',
    getParentRoute: () => CrmProposalsRoute,
  } as any).lazy(() =>
    import('./routes/crm/proposals/$proposalId_.edit.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agencies': typeof AgenciesRouteWithChildren
  '/agent': typeof AgentRouteWithChildren
  '/browser-live': typeof BrowserLiveRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/clients': typeof ClientsRouteWithChildren
  '/crm': typeof CrmRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/documents': typeof DocumentsRouteWithChildren
  '/engagements': typeof EngagementsRouteWithChildren
  '/entities': typeof EntitiesRouteWithChildren
  '/import-center': typeof ImportCenterRoute
  '/integrations': typeof IntegrationsRouteWithChildren
  '/invoices': typeof InvoicesRouteWithChildren
  '/org-chart': typeof OrgChartRoute
  '/proposals': typeof ProposalsRouteWithChildren
  '/providers': typeof ProvidersRouteWithChildren
  '/relationships': typeof RelationshipsRoute
  '/reports': typeof ReportsRoute
  '/risk': typeof RiskRoute
  '/time': typeof TimeRouteWithChildren
  '/workforce': typeof WorkforceRouteWithChildren
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/agency/pending': typeof AgencyPendingRoute
  '/agent/$sessionId': typeof AgentSessionIdRoute
  '/agreements/$agreementId': typeof AgreementsAgreementIdRoute
  '/ask/$conversationId': typeof AskConversationIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/compliance/calendar': typeof ComplianceCalendarRoute
  '/crm/catalog': typeof CrmCatalogRoute
  '/crm/contacts': typeof CrmContactsRoute
  '/crm/handover': typeof CrmHandoverRoute
  '/crm/leads': typeof CrmLeadsRoute
  '/crm/my-work': typeof CrmMyWorkRoute
  '/crm/opportunities': typeof CrmOpportunitiesRoute
  '/crm/proposals': typeof CrmProposalsRouteWithChildren
  '/crm/settings': typeof CrmSettingsRoute
  '/documents/$instanceId': typeof DocumentsInstanceIdRoute
  '/documents/uploaded': typeof DocumentsUploadedRouteWithChildren
  '/engagements/$engagementId': typeof EngagementsEngagementIdRoute
  '/engagements/new': typeof EngagementsNewRoute
  '/entities/$entityId': typeof EntitiesEntityIdRoute
  '/entities/bulk-import': typeof EntitiesBulkImportRoute
  '/entities/new': typeof EntitiesNewRoute
  '/forms/admin': typeof FormsAdminRouteWithChildren
  '/forms/library': typeof FormsLibraryRoute
  '/integrations/books': typeof IntegrationsBooksRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/invoices/categories': typeof InvoicesCategoriesRoute
  '/invoices/custom-fields': typeof InvoicesCustomFieldsRoute
  '/invoices/dues': typeof InvoicesDuesRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/invoices/service-catalogue': typeof InvoicesServiceCatalogueRoute
  '/invoices/tax-rules': typeof InvoicesTaxRulesRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/onboarding/agency': typeof OnboardingAgencyRoute
  '/onboarding/client': typeof OnboardingClientRoute
  '/onboarding/eor-aor': typeof OnboardingEorAorRoute
  '/onboarding/vendor': typeof OnboardingVendorRoute
  '/onboarding/worker': typeof OnboardingWorkerRoute
  '/ownership/structure': typeof OwnershipStructureRoute
  '/people/$personId': typeof PeoplePersonIdRoute
  '/people/new': typeof PeopleNewRoute
  '/proposals/$proposalId': typeof ProposalsProposalIdRoute
  '/proposals/approvals': typeof ProposalsApprovalsRoute
  '/proposals/new': typeof ProposalsNewRoute
  '/providers/$vendorId': typeof ProvidersVendorIdRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/invite-member': typeof SettingsInviteMemberRoute
  '/time/attendance': typeof TimeAttendanceRoute
  '/time/availability': typeof TimeAvailabilityRoute
  '/time/cycles': typeof TimeCyclesRoute
  '/time/holidays': typeof TimeHolidaysRoute
  '/time/logs': typeof TimeLogsRouteWithChildren
  '/time/my-setup': typeof TimeMySetupRoute
  '/time/my-time': typeof TimeMyTimeRoute
  '/time/off': typeof TimeOffRouteWithChildren
  '/time/policies': typeof TimePoliciesRoute
  '/time/submissions': typeof TimeSubmissionsRoute
  '/time/workforce-plan': typeof TimeWorkforcePlanRoute
  '/workforce/$workerId': typeof WorkforceWorkerIdRoute
  '/browser-live/$sessionId': typeof BrowserLiveSessionIdLazyRoute
  '/agencies/': typeof AgenciesIndexRoute
  '/ask/': typeof AskIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/compliance/': typeof ComplianceIndexRoute
  '/crm/': typeof CrmIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/engagements/': typeof EngagementsIndexRoute
  '/entities/': typeof EntitiesIndexRoute
  '/favourites/': typeof FavouritesIndexRoute
  '/forms/': typeof FormsIndexRoute
  '/help-requests/': typeof HelpRequestsIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/proposals/': typeof ProposalsIndexRoute
  '/providers/': typeof ProvidersIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/template-engine/': typeof TemplateEngineIndexRoute
  '/time/': typeof TimeIndexRoute
  '/workforce/': typeof WorkforceIndexRoute
  '/crm/proposals/$proposalId': typeof CrmProposalsProposalIdRoute
  '/crm/proposals/approvals': typeof CrmProposalsApprovalsRoute
  '/crm/proposals/new': typeof CrmProposalsNewRoute
  '/documents/uploaded/$documentId': typeof DocumentsUploadedDocumentIdRoute
  '/engagements/$engagementId/intake': typeof EngagementsEngagementIdIntakeRoute
  '/forms/admin/new': typeof FormsAdminNewRoute
  '/forms/templates/$templateId': typeof FormsTemplatesTemplateIdRoute
  '/forms/templates/new': typeof FormsTemplatesNewRoute
  '/integrations/connections/$id': typeof IntegrationsConnectionsIdRouteWithChildren
  '/integrations/providers/$providerId': typeof IntegrationsProvidersProviderIdRouteWithChildren
  '/proposals/$proposalId/edit': typeof ProposalsProposalIdEditRoute
  '/proposals/$proposalId/review': typeof ProposalsProposalIdReviewRoute
  '/template-engine/templates/$templateId': typeof TemplateEngineTemplatesTemplateIdRoute
  '/template-engine/templates/new': typeof TemplateEngineTemplatesNewRoute
  '/time/logs/$timesheetId': typeof TimeLogsTimesheetIdRoute
  '/ask/canvas/': typeof AskCanvasIndexRoute
  '/crm/proposals/': typeof CrmProposalsIndexRoute
  '/forms/templates/': typeof FormsTemplatesIndexRoute
  '/platform/agencies/': typeof PlatformAgenciesIndexRoute
  '/template-engine/templates/': typeof TemplateEngineTemplatesIndexRoute
  '/time/logs/': typeof TimeLogsIndexRoute
  '/time/off/': typeof TimeOffIndexRoute
  '/crm/proposals/$proposalId/edit': typeof CrmProposalsProposalIdEditRoute
  '/crm/proposals/$proposalId/review': typeof CrmProposalsProposalIdReviewRoute
  '/integrations/connections/$id/mappings': typeof IntegrationsConnectionsIdMappingsRoute
  '/integrations/providers/$providerId/discovery': typeof IntegrationsProvidersProviderIdDiscoveryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agent': typeof AgentRouteWithChildren
  '/browser-live': typeof BrowserLiveRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/import-center': typeof ImportCenterRoute
  '/org-chart': typeof OrgChartRoute
  '/relationships': typeof RelationshipsRoute
  '/reports': typeof ReportsRoute
  '/risk': typeof RiskRoute
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/agency/pending': typeof AgencyPendingRoute
  '/agent/$sessionId': typeof AgentSessionIdRoute
  '/agreements/$agreementId': typeof AgreementsAgreementIdRoute
  '/ask/$conversationId': typeof AskConversationIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/compliance/calendar': typeof ComplianceCalendarRoute
  '/crm/catalog': typeof CrmCatalogRoute
  '/crm/contacts': typeof CrmContactsRoute
  '/crm/handover': typeof CrmHandoverRoute
  '/crm/leads': typeof CrmLeadsRoute
  '/crm/my-work': typeof CrmMyWorkRoute
  '/crm/opportunities': typeof CrmOpportunitiesRoute
  '/crm/settings': typeof CrmSettingsRoute
  '/documents/$instanceId': typeof DocumentsInstanceIdRoute
  '/documents/uploaded': typeof DocumentsUploadedRouteWithChildren
  '/engagements/$engagementId': typeof EngagementsEngagementIdRoute
  '/engagements/new': typeof EngagementsNewRoute
  '/entities/$entityId': typeof EntitiesEntityIdRoute
  '/entities/bulk-import': typeof EntitiesBulkImportRoute
  '/entities/new': typeof EntitiesNewRoute
  '/forms/admin': typeof FormsAdminRouteWithChildren
  '/forms/library': typeof FormsLibraryRoute
  '/integrations/books': typeof IntegrationsBooksRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/invoices/categories': typeof InvoicesCategoriesRoute
  '/invoices/custom-fields': typeof InvoicesCustomFieldsRoute
  '/invoices/dues': typeof InvoicesDuesRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/invoices/service-catalogue': typeof InvoicesServiceCatalogueRoute
  '/invoices/tax-rules': typeof InvoicesTaxRulesRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/onboarding/agency': typeof OnboardingAgencyRoute
  '/onboarding/client': typeof OnboardingClientRoute
  '/onboarding/eor-aor': typeof OnboardingEorAorRoute
  '/onboarding/vendor': typeof OnboardingVendorRoute
  '/onboarding/worker': typeof OnboardingWorkerRoute
  '/ownership/structure': typeof OwnershipStructureRoute
  '/people/$personId': typeof PeoplePersonIdRoute
  '/people/new': typeof PeopleNewRoute
  '/proposals/$proposalId': typeof ProposalsProposalIdRoute
  '/proposals/approvals': typeof ProposalsApprovalsRoute
  '/proposals/new': typeof ProposalsNewRoute
  '/providers/$vendorId': typeof ProvidersVendorIdRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/invite-member': typeof SettingsInviteMemberRoute
  '/time/attendance': typeof TimeAttendanceRoute
  '/time/availability': typeof TimeAvailabilityRoute
  '/time/cycles': typeof TimeCyclesRoute
  '/time/holidays': typeof TimeHolidaysRoute
  '/time/my-setup': typeof TimeMySetupRoute
  '/time/my-time': typeof TimeMyTimeRoute
  '/time/policies': typeof TimePoliciesRoute
  '/time/submissions': typeof TimeSubmissionsRoute
  '/time/workforce-plan': typeof TimeWorkforcePlanRoute
  '/workforce/$workerId': typeof WorkforceWorkerIdRoute
  '/browser-live/$sessionId': typeof BrowserLiveSessionIdLazyRoute
  '/agencies': typeof AgenciesIndexRoute
  '/ask': typeof AskIndexRoute
  '/clients': typeof ClientsIndexRoute
  '/compliance': typeof ComplianceIndexRoute
  '/crm': typeof CrmIndexRoute
  '/documents': typeof DocumentsIndexRoute
  '/engagements': typeof EngagementsIndexRoute
  '/entities': typeof EntitiesIndexRoute
  '/favourites': typeof FavouritesIndexRoute
  '/forms': typeof FormsIndexRoute
  '/help-requests': typeof HelpRequestsIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/invoices': typeof InvoicesIndexRoute
  '/people': typeof PeopleIndexRoute
  '/proposals': typeof ProposalsIndexRoute
  '/providers': typeof ProvidersIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/template-engine': typeof TemplateEngineIndexRoute
  '/time': typeof TimeIndexRoute
  '/workforce': typeof WorkforceIndexRoute
  '/crm/proposals/$proposalId': typeof CrmProposalsProposalIdRoute
  '/crm/proposals/approvals': typeof CrmProposalsApprovalsRoute
  '/crm/proposals/new': typeof CrmProposalsNewRoute
  '/documents/uploaded/$documentId': typeof DocumentsUploadedDocumentIdRoute
  '/engagements/$engagementId/intake': typeof EngagementsEngagementIdIntakeRoute
  '/forms/admin/new': typeof FormsAdminNewRoute
  '/forms/templates/$templateId': typeof FormsTemplatesTemplateIdRoute
  '/forms/templates/new': typeof FormsTemplatesNewRoute
  '/integrations/connections/$id': typeof IntegrationsConnectionsIdRouteWithChildren
  '/integrations/providers/$providerId': typeof IntegrationsProvidersProviderIdRouteWithChildren
  '/proposals/$proposalId/edit': typeof ProposalsProposalIdEditRoute
  '/proposals/$proposalId/review': typeof ProposalsProposalIdReviewRoute
  '/template-engine/templates/$templateId': typeof TemplateEngineTemplatesTemplateIdRoute
  '/template-engine/templates/new': typeof TemplateEngineTemplatesNewRoute
  '/time/logs/$timesheetId': typeof TimeLogsTimesheetIdRoute
  '/ask/canvas': typeof AskCanvasIndexRoute
  '/crm/proposals': typeof CrmProposalsIndexRoute
  '/forms/templates': typeof FormsTemplatesIndexRoute
  '/platform/agencies': typeof PlatformAgenciesIndexRoute
  '/template-engine/templates': typeof TemplateEngineTemplatesIndexRoute
  '/time/logs': typeof TimeLogsIndexRoute
  '/time/off': typeof TimeOffIndexRoute
  '/crm/proposals/$proposalId/edit': typeof CrmProposalsProposalIdEditRoute
  '/crm/proposals/$proposalId/review': typeof CrmProposalsProposalIdReviewRoute
  '/integrations/connections/$id/mappings': typeof IntegrationsConnectionsIdMappingsRoute
  '/integrations/providers/$providerId/discovery': typeof IntegrationsProvidersProviderIdDiscoveryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agencies': typeof AgenciesRouteWithChildren
  '/agent': typeof AgentRouteWithChildren
  '/browser-live': typeof BrowserLiveRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/clients': typeof ClientsRouteWithChildren
  '/crm': typeof CrmRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/documents': typeof DocumentsRouteWithChildren
  '/engagements': typeof EngagementsRouteWithChildren
  '/entities': typeof EntitiesRouteWithChildren
  '/import-center': typeof ImportCenterRoute
  '/integrations': typeof IntegrationsRouteWithChildren
  '/invoices': typeof InvoicesRouteWithChildren
  '/org-chart': typeof OrgChartRoute
  '/proposals': typeof ProposalsRouteWithChildren
  '/providers': typeof ProvidersRouteWithChildren
  '/relationships': typeof RelationshipsRoute
  '/reports': typeof ReportsRoute
  '/risk': typeof RiskRoute
  '/time': typeof TimeRouteWithChildren
  '/workforce': typeof WorkforceRouteWithChildren
  '/agencies/$agencyId': typeof AgenciesAgencyIdRoute
  '/agency/pending': typeof AgencyPendingRoute
  '/agent/$sessionId': typeof AgentSessionIdRoute
  '/agreements/$agreementId': typeof AgreementsAgreementIdRoute
  '/ask/$conversationId': typeof AskConversationIdRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/compliance/calendar': typeof ComplianceCalendarRoute
  '/crm/catalog': typeof CrmCatalogRoute
  '/crm/contacts': typeof CrmContactsRoute
  '/crm/handover': typeof CrmHandoverRoute
  '/crm/leads': typeof CrmLeadsRoute
  '/crm/my-work': typeof CrmMyWorkRoute
  '/crm/opportunities': typeof CrmOpportunitiesRoute
  '/crm/proposals': typeof CrmProposalsRouteWithChildren
  '/crm/settings': typeof CrmSettingsRoute
  '/documents/$instanceId': typeof DocumentsInstanceIdRoute
  '/documents/uploaded': typeof DocumentsUploadedRouteWithChildren
  '/engagements/$engagementId': typeof EngagementsEngagementIdRoute
  '/engagements/new': typeof EngagementsNewRoute
  '/entities/$entityId': typeof EntitiesEntityIdRoute
  '/entities/bulk-import': typeof EntitiesBulkImportRoute
  '/entities/new': typeof EntitiesNewRoute
  '/forms/admin': typeof FormsAdminRouteWithChildren
  '/forms/library': typeof FormsLibraryRoute
  '/integrations/books': typeof IntegrationsBooksRoute
  '/invoices/$invoiceId': typeof InvoicesInvoiceIdRoute
  '/invoices/categories': typeof InvoicesCategoriesRoute
  '/invoices/custom-fields': typeof InvoicesCustomFieldsRoute
  '/invoices/dues': typeof InvoicesDuesRoute
  '/invoices/new': typeof InvoicesNewRoute
  '/invoices/service-catalogue': typeof InvoicesServiceCatalogueRoute
  '/invoices/tax-rules': typeof InvoicesTaxRulesRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/onboarding/agency': typeof OnboardingAgencyRoute
  '/onboarding/client': typeof OnboardingClientRoute
  '/onboarding/eor-aor': typeof OnboardingEorAorRoute
  '/onboarding/vendor': typeof OnboardingVendorRoute
  '/onboarding/worker': typeof OnboardingWorkerRoute
  '/ownership/structure': typeof OwnershipStructureRoute
  '/people/$personId': typeof PeoplePersonIdRoute
  '/people/new': typeof PeopleNewRoute
  '/proposals/$proposalId': typeof ProposalsProposalIdRoute
  '/proposals/approvals': typeof ProposalsApprovalsRoute
  '/proposals/new': typeof ProposalsNewRoute
  '/providers/$vendorId': typeof ProvidersVendorIdRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/invite-member': typeof SettingsInviteMemberRoute
  '/time/attendance': typeof TimeAttendanceRoute
  '/time/availability': typeof TimeAvailabilityRoute
  '/time/cycles': typeof TimeCyclesRoute
  '/time/holidays': typeof TimeHolidaysRoute
  '/time/logs': typeof TimeLogsRouteWithChildren
  '/time/my-setup': typeof TimeMySetupRoute
  '/time/my-time': typeof TimeMyTimeRoute
  '/time/off': typeof TimeOffRouteWithChildren
  '/time/policies': typeof TimePoliciesRoute
  '/time/submissions': typeof TimeSubmissionsRoute
  '/time/workforce-plan': typeof TimeWorkforcePlanRoute
  '/workforce/$workerId': typeof WorkforceWorkerIdRoute
  '/browser-live/$sessionId': typeof BrowserLiveSessionIdLazyRoute
  '/agencies/': typeof AgenciesIndexRoute
  '/ask/': typeof AskIndexRoute
  '/clients/': typeof ClientsIndexRoute
  '/compliance/': typeof ComplianceIndexRoute
  '/crm/': typeof CrmIndexRoute
  '/documents/': typeof DocumentsIndexRoute
  '/engagements/': typeof EngagementsIndexRoute
  '/entities/': typeof EntitiesIndexRoute
  '/favourites/': typeof FavouritesIndexRoute
  '/forms/': typeof FormsIndexRoute
  '/help-requests/': typeof HelpRequestsIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/invoices/': typeof InvoicesIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/proposals/': typeof ProposalsIndexRoute
  '/providers/': typeof ProvidersIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/template-engine/': typeof TemplateEngineIndexRoute
  '/time/': typeof TimeIndexRoute
  '/workforce/': typeof WorkforceIndexRoute
  '/crm/proposals/$proposalId': typeof CrmProposalsProposalIdRoute
  '/crm/proposals/approvals': typeof CrmProposalsApprovalsRoute
  '/crm/proposals/new': typeof CrmProposalsNewRoute
  '/documents/uploaded/$documentId': typeof DocumentsUploadedDocumentIdRoute
  '/engagements/$engagementId_/intake': typeof EngagementsEngagementIdIntakeRoute
  '/forms/admin/new': typeof FormsAdminNewRoute
  '/forms/templates/$templateId': typeof FormsTemplatesTemplateIdRoute
  '/forms/templates/new': typeof FormsTemplatesNewRoute
  '/integrations/connections/$id': typeof IntegrationsConnectionsIdRouteWithChildren
  '/integrations/providers/$providerId': typeof IntegrationsProvidersProviderIdRouteWithChildren
  '/proposals/$proposalId_/edit': typeof ProposalsProposalIdEditRoute
  '/proposals/$proposalId_/review': typeof ProposalsProposalIdReviewRoute
  '/template-engine/templates/$templateId': typeof TemplateEngineTemplatesTemplateIdRoute
  '/template-engine/templates/new': typeof TemplateEngineTemplatesNewRoute
  '/time/logs/$timesheetId': typeof TimeLogsTimesheetIdRoute
  '/ask/canvas/': typeof AskCanvasIndexRoute
  '/crm/proposals/': typeof CrmProposalsIndexRoute
  '/forms/templates/': typeof FormsTemplatesIndexRoute
  '/platform/agencies/': typeof PlatformAgenciesIndexRoute
  '/template-engine/templates/': typeof TemplateEngineTemplatesIndexRoute
  '/time/logs/': typeof TimeLogsIndexRoute
  '/time/off/': typeof TimeOffIndexRoute
  '/crm/proposals/$proposalId_/edit': typeof CrmProposalsProposalIdEditRoute
  '/crm/proposals/$proposalId_/review': typeof CrmProposalsProposalIdReviewRoute
  '/integrations/connections/$id/mappings': typeof IntegrationsConnectionsIdMappingsRoute
  '/integrations/providers/$providerId/discovery': typeof IntegrationsProvidersProviderIdDiscoveryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agencies'
    | '/agent'
    | '/browser-live'
    | '/calendar'
    | '/clients'
    | '/crm'
    | '/dashboard'
    | '/documents'
    | '/engagements'
    | '/entities'
    | '/import-center'
    | '/integrations'
    | '/invoices'
    | '/org-chart'
    | '/proposals'
    | '/providers'
    | '/relationships'
    | '/reports'
    | '/risk'
    | '/time'
    | '/workforce'
    | '/agencies/$agencyId'
    | '/agency/pending'
    | '/agent/$sessionId'
    | '/agreements/$agreementId'
    | '/ask/$conversationId'
    | '/clients/$clientId'
    | '/compliance/calendar'
    | '/crm/catalog'
    | '/crm/contacts'
    | '/crm/handover'
    | '/crm/leads'
    | '/crm/my-work'
    | '/crm/opportunities'
    | '/crm/proposals'
    | '/crm/settings'
    | '/documents/$instanceId'
    | '/documents/uploaded'
    | '/engagements/$engagementId'
    | '/engagements/new'
    | '/entities/$entityId'
    | '/entities/bulk-import'
    | '/entities/new'
    | '/forms/admin'
    | '/forms/library'
    | '/integrations/books'
    | '/invoices/$invoiceId'
    | '/invoices/categories'
    | '/invoices/custom-fields'
    | '/invoices/dues'
    | '/invoices/new'
    | '/invoices/service-catalogue'
    | '/invoices/tax-rules'
    | '/oauth/callback'
    | '/onboarding/agency'
    | '/onboarding/client'
    | '/onboarding/eor-aor'
    | '/onboarding/vendor'
    | '/onboarding/worker'
    | '/ownership/structure'
    | '/people/$personId'
    | '/people/new'
    | '/proposals/$proposalId'
    | '/proposals/approvals'
    | '/proposals/new'
    | '/providers/$vendorId'
    | '/settings/branding'
    | '/settings/invite-member'
    | '/time/attendance'
    | '/time/availability'
    | '/time/cycles'
    | '/time/holidays'
    | '/time/logs'
    | '/time/my-setup'
    | '/time/my-time'
    | '/time/off'
    | '/time/policies'
    | '/time/submissions'
    | '/time/workforce-plan'
    | '/workforce/$workerId'
    | '/browser-live/$sessionId'
    | '/agencies/'
    | '/ask/'
    | '/clients/'
    | '/compliance/'
    | '/crm/'
    | '/documents/'
    | '/engagements/'
    | '/entities/'
    | '/favourites/'
    | '/forms/'
    | '/help-requests/'
    | '/integrations/'
    | '/invoices/'
    | '/people/'
    | '/proposals/'
    | '/providers/'
    | '/settings/'
    | '/template-engine/'
    | '/time/'
    | '/workforce/'
    | '/crm/proposals/$proposalId'
    | '/crm/proposals/approvals'
    | '/crm/proposals/new'
    | '/documents/uploaded/$documentId'
    | '/engagements/$engagementId/intake'
    | '/forms/admin/new'
    | '/forms/templates/$templateId'
    | '/forms/templates/new'
    | '/integrations/connections/$id'
    | '/integrations/providers/$providerId'
    | '/proposals/$proposalId/edit'
    | '/proposals/$proposalId/review'
    | '/template-engine/templates/$templateId'
    | '/template-engine/templates/new'
    | '/time/logs/$timesheetId'
    | '/ask/canvas/'
    | '/crm/proposals/'
    | '/forms/templates/'
    | '/platform/agencies/'
    | '/template-engine/templates/'
    | '/time/logs/'
    | '/time/off/'
    | '/crm/proposals/$proposalId/edit'
    | '/crm/proposals/$proposalId/review'
    | '/integrations/connections/$id/mappings'
    | '/integrations/providers/$providerId/discovery'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agent'
    | '/browser-live'
    | '/calendar'
    | '/dashboard'
    | '/import-center'
    | '/org-chart'
    | '/relationships'
    | '/reports'
    | '/risk'
    | '/agencies/$agencyId'
    | '/agency/pending'
    | '/agent/$sessionId'
    | '/agreements/$agreementId'
    | '/ask/$conversationId'
    | '/clients/$clientId'
    | '/compliance/calendar'
    | '/crm/catalog'
    | '/crm/contacts'
    | '/crm/handover'
    | '/crm/leads'
    | '/crm/my-work'
    | '/crm/opportunities'
    | '/crm/settings'
    | '/documents/$instanceId'
    | '/documents/uploaded'
    | '/engagements/$engagementId'
    | '/engagements/new'
    | '/entities/$entityId'
    | '/entities/bulk-import'
    | '/entities/new'
    | '/forms/admin'
    | '/forms/library'
    | '/integrations/books'
    | '/invoices/$invoiceId'
    | '/invoices/categories'
    | '/invoices/custom-fields'
    | '/invoices/dues'
    | '/invoices/new'
    | '/invoices/service-catalogue'
    | '/invoices/tax-rules'
    | '/oauth/callback'
    | '/onboarding/agency'
    | '/onboarding/client'
    | '/onboarding/eor-aor'
    | '/onboarding/vendor'
    | '/onboarding/worker'
    | '/ownership/structure'
    | '/people/$personId'
    | '/people/new'
    | '/proposals/$proposalId'
    | '/proposals/approvals'
    | '/proposals/new'
    | '/providers/$vendorId'
    | '/settings/branding'
    | '/settings/invite-member'
    | '/time/attendance'
    | '/time/availability'
    | '/time/cycles'
    | '/time/holidays'
    | '/time/my-setup'
    | '/time/my-time'
    | '/time/policies'
    | '/time/submissions'
    | '/time/workforce-plan'
    | '/workforce/$workerId'
    | '/browser-live/$sessionId'
    | '/agencies'
    | '/ask'
    | '/clients'
    | '/compliance'
    | '/crm'
    | '/documents'
    | '/engagements'
    | '/entities'
    | '/favourites'
    | '/forms'
    | '/help-requests'
    | '/integrations'
    | '/invoices'
    | '/people'
    | '/proposals'
    | '/providers'
    | '/settings'
    | '/template-engine'
    | '/time'
    | '/workforce'
    | '/crm/proposals/$proposalId'
    | '/crm/proposals/approvals'
    | '/crm/proposals/new'
    | '/documents/uploaded/$documentId'
    | '/engagements/$engagementId/intake'
    | '/forms/admin/new'
    | '/forms/templates/$templateId'
    | '/forms/templates/new'
    | '/integrations/connections/$id'
    | '/integrations/providers/$providerId'
    | '/proposals/$proposalId/edit'
    | '/proposals/$proposalId/review'
    | '/template-engine/templates/$templateId'
    | '/template-engine/templates/new'
    | '/time/logs/$timesheetId'
    | '/ask/canvas'
    | '/crm/proposals'
    | '/forms/templates'
    | '/platform/agencies'
    | '/template-engine/templates'
    | '/time/logs'
    | '/time/off'
    | '/crm/proposals/$proposalId/edit'
    | '/crm/proposals/$proposalId/review'
    | '/integrations/connections/$id/mappings'
    | '/integrations/providers/$providerId/discovery'
  id:
    | '__root__'
    | '/'
    | '/agencies'
    | '/agent'
    | '/browser-live'
    | '/calendar'
    | '/clients'
    | '/crm'
    | '/dashboard'
    | '/documents'
    | '/engagements'
    | '/entities'
    | '/import-center'
    | '/integrations'
    | '/invoices'
    | '/org-chart'
    | '/proposals'
    | '/providers'
    | '/relationships'
    | '/reports'
    | '/risk'
    | '/time'
    | '/workforce'
    | '/agencies/$agencyId'
    | '/agency/pending'
    | '/agent/$sessionId'
    | '/agreements/$agreementId'
    | '/ask/$conversationId'
    | '/clients/$clientId'
    | '/compliance/calendar'
    | '/crm/catalog'
    | '/crm/contacts'
    | '/crm/handover'
    | '/crm/leads'
    | '/crm/my-work'
    | '/crm/opportunities'
    | '/crm/proposals'
    | '/crm/settings'
    | '/documents/$instanceId'
    | '/documents/uploaded'
    | '/engagements/$engagementId'
    | '/engagements/new'
    | '/entities/$entityId'
    | '/entities/bulk-import'
    | '/entities/new'
    | '/forms/admin'
    | '/forms/library'
    | '/integrations/books'
    | '/invoices/$invoiceId'
    | '/invoices/categories'
    | '/invoices/custom-fields'
    | '/invoices/dues'
    | '/invoices/new'
    | '/invoices/service-catalogue'
    | '/invoices/tax-rules'
    | '/oauth/callback'
    | '/onboarding/agency'
    | '/onboarding/client'
    | '/onboarding/eor-aor'
    | '/onboarding/vendor'
    | '/onboarding/worker'
    | '/ownership/structure'
    | '/people/$personId'
    | '/people/new'
    | '/proposals/$proposalId'
    | '/proposals/approvals'
    | '/proposals/new'
    | '/providers/$vendorId'
    | '/settings/branding'
    | '/settings/invite-member'
    | '/time/attendance'
    | '/time/availability'
    | '/time/cycles'
    | '/time/holidays'
    | '/time/logs'
    | '/time/my-setup'
    | '/time/my-time'
    | '/time/off'
    | '/time/policies'
    | '/time/submissions'
    | '/time/workforce-plan'
    | '/workforce/$workerId'
    | '/browser-live/$sessionId'
    | '/agencies/'
    | '/ask/'
    | '/clients/'
    | '/compliance/'
    | '/crm/'
    | '/documents/'
    | '/engagements/'
    | '/entities/'
    | '/favourites/'
    | '/forms/'
    | '/help-requests/'
    | '/integrations/'
    | '/invoices/'
    | '/people/'
    | '/proposals/'
    | '/providers/'
    | '/settings/'
    | '/template-engine/'
    | '/time/'
    | '/workforce/'
    | '/crm/proposals/$proposalId'
    | '/crm/proposals/approvals'
    | '/crm/proposals/new'
    | '/documents/uploaded/$documentId'
    | '/engagements/$engagementId_/intake'
    | '/forms/admin/new'
    | '/forms/templates/$templateId'
    | '/forms/templates/new'
    | '/integrations/connections/$id'
    | '/integrations/providers/$providerId'
    | '/proposals/$proposalId_/edit'
    | '/proposals/$proposalId_/review'
    | '/template-engine/templates/$templateId'
    | '/template-engine/templates/new'
    | '/time/logs/$timesheetId'
    | '/ask/canvas/'
    | '/crm/proposals/'
    | '/forms/templates/'
    | '/platform/agencies/'
    | '/template-engine/templates/'
    | '/time/logs/'
    | '/time/off/'
    | '/crm/proposals/$proposalId_/edit'
    | '/crm/proposals/$proposalId_/review'
    | '/integrations/connections/$id/mappings'
    | '/integrations/providers/$providerId/discovery'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgenciesRoute: typeof AgenciesRouteWithChildren
  AgentRoute: typeof AgentRouteWithChildren
  BrowserLiveRoute: typeof BrowserLiveRouteWithChildren
  CalendarRoute: typeof CalendarRoute
  ClientsRoute: typeof ClientsRouteWithChildren
  CrmRoute: typeof CrmRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  DocumentsRoute: typeof DocumentsRouteWithChildren
  EngagementsRoute: typeof EngagementsRouteWithChildren
  EntitiesRoute: typeof EntitiesRouteWithChildren
  ImportCenterRoute: typeof ImportCenterRoute
  IntegrationsRoute: typeof IntegrationsRouteWithChildren
  InvoicesRoute: typeof InvoicesRouteWithChildren
  OrgChartRoute: typeof OrgChartRoute
  ProposalsRoute: typeof ProposalsRouteWithChildren
  ProvidersRoute: typeof ProvidersRouteWithChildren
  RelationshipsRoute: typeof RelationshipsRoute
  ReportsRoute: typeof ReportsRoute
  RiskRoute: typeof RiskRoute
  TimeRoute: typeof TimeRouteWithChildren
  WorkforceRoute: typeof WorkforceRouteWithChildren
  AgencyPendingRoute: typeof AgencyPendingRoute
  AgreementsAgreementIdRoute: typeof AgreementsAgreementIdRoute
  AskConversationIdRoute: typeof AskConversationIdRoute
  ComplianceCalendarRoute: typeof ComplianceCalendarRoute
  FormsAdminRoute: typeof FormsAdminRouteWithChildren
  FormsLibraryRoute: typeof FormsLibraryRoute
  OauthCallbackRoute: typeof OauthCallbackRoute
  OnboardingAgencyRoute: typeof OnboardingAgencyRoute
  OnboardingClientRoute: typeof OnboardingClientRoute
  OnboardingEorAorRoute: typeof OnboardingEorAorRoute
  OnboardingVendorRoute: typeof OnboardingVendorRoute
  OnboardingWorkerRoute: typeof OnboardingWorkerRoute
  OwnershipStructureRoute: typeof OwnershipStructureRoute
  PeoplePersonIdRoute: typeof PeoplePersonIdRoute
  PeopleNewRoute: typeof PeopleNewRoute
  SettingsBrandingRoute: typeof SettingsBrandingRoute
  SettingsInviteMemberRoute: typeof SettingsInviteMemberRoute
  AskIndexRoute: typeof AskIndexRoute
  ComplianceIndexRoute: typeof ComplianceIndexRoute
  FavouritesIndexRoute: typeof FavouritesIndexRoute
  FormsIndexRoute: typeof FormsIndexRoute
  HelpRequestsIndexRoute: typeof HelpRequestsIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TemplateEngineIndexRoute: typeof TemplateEngineIndexRoute
  FormsTemplatesTemplateIdRoute: typeof FormsTemplatesTemplateIdRoute
  FormsTemplatesNewRoute: typeof FormsTemplatesNewRoute
  TemplateEngineTemplatesTemplateIdRoute: typeof TemplateEngineTemplatesTemplateIdRoute
  TemplateEngineTemplatesNewRoute: typeof TemplateEngineTemplatesNewRoute
  AskCanvasIndexRoute: typeof AskCanvasIndexRoute
  FormsTemplatesIndexRoute: typeof FormsTemplatesIndexRoute
  PlatformAgenciesIndexRoute: typeof PlatformAgenciesIndexRoute
  TemplateEngineTemplatesIndexRoute: typeof TemplateEngineTemplatesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workforce': {
      id: '/workforce'
      path: '/workforce'
      fullPath: '/workforce'
      preLoaderRoute: typeof WorkforceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/time': {
      id: '/time'
      path: '/time'
      fullPath: '/time'
      preLoaderRoute: typeof TimeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk': {
      id: '/risk'
      path: '/risk'
      fullPath: '/risk'
      preLoaderRoute: typeof RiskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relationships': {
      id: '/relationships'
      path: '/relationships'
      fullPath: '/relationships'
      preLoaderRoute: typeof RelationshipsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers': {
      id: '/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof ProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposals': {
      id: '/proposals'
      path: '/proposals'
      fullPath: '/proposals'
      preLoaderRoute: typeof ProposalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org-chart': {
      id: '/org-chart'
      path: '/org-chart'
      fullPath: '/org-chart'
      preLoaderRoute: typeof OrgChartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import-center': {
      id: '/import-center'
      path: '/import-center'
      fullPath: '/import-center'
      preLoaderRoute: typeof ImportCenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities': {
      id: '/entities'
      path: '/entities'
      fullPath: '/entities'
      preLoaderRoute: typeof EntitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/engagements': {
      id: '/engagements'
      path: '/engagements'
      fullPath: '/engagements'
      preLoaderRoute: typeof EngagementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm': {
      id: '/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof CrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/browser-live': {
      id: '/browser-live'
      path: '/browser-live'
      fullPath: '/browser-live'
      preLoaderRoute: typeof BrowserLiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent': {
      id: '/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agencies': {
      id: '/agencies'
      path: '/agencies'
      fullPath: '/agencies'
      preLoaderRoute: typeof AgenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workforce/': {
      id: '/workforce/'
      path: '/'
      fullPath: '/workforce/'
      preLoaderRoute: typeof WorkforceIndexRouteImport
      parentRoute: typeof WorkforceRoute
    }
    '/time/': {
      id: '/time/'
      path: '/'
      fullPath: '/time/'
      preLoaderRoute: typeof TimeIndexRouteImport
      parentRoute: typeof TimeRoute
    }
    '/template-engine/': {
      id: '/template-engine/'
      path: '/template-engine'
      fullPath: '/template-engine/'
      preLoaderRoute: typeof TemplateEngineIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers/': {
      id: '/providers/'
      path: '/'
      fullPath: '/providers/'
      preLoaderRoute: typeof ProvidersIndexRouteImport
      parentRoute: typeof ProvidersRoute
    }
    '/proposals/': {
      id: '/proposals/'
      path: '/'
      fullPath: '/proposals/'
      preLoaderRoute: typeof ProposalsIndexRouteImport
      parentRoute: typeof ProposalsRoute
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/': {
      id: '/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof InvoicesIndexRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/help-requests/': {
      id: '/help-requests/'
      path: '/help-requests'
      fullPath: '/help-requests/'
      preLoaderRoute: typeof HelpRequestsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/': {
      id: '/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof FormsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favourites/': {
      id: '/favourites/'
      path: '/favourites'
      fullPath: '/favourites/'
      preLoaderRoute: typeof FavouritesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities/': {
      id: '/entities/'
      path: '/'
      fullPath: '/entities/'
      preLoaderRoute: typeof EntitiesIndexRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/engagements/': {
      id: '/engagements/'
      path: '/'
      fullPath: '/engagements/'
      preLoaderRoute: typeof EngagementsIndexRouteImport
      parentRoute: typeof EngagementsRoute
    }
    '/documents/': {
      id: '/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof DocumentsIndexRouteImport
      parentRoute: typeof DocumentsRoute
    }
    '/crm/': {
      id: '/crm/'
      path: '/'
      fullPath: '/crm/'
      preLoaderRoute: typeof CrmIndexRouteImport
      parentRoute: typeof CrmRoute
    }
    '/compliance/': {
      id: '/compliance/'
      path: '/compliance'
      fullPath: '/compliance/'
      preLoaderRoute: typeof ComplianceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof ClientsRoute
    }
    '/ask/': {
      id: '/ask/'
      path: '/ask'
      fullPath: '/ask/'
      preLoaderRoute: typeof AskIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agencies/': {
      id: '/agencies/'
      path: '/'
      fullPath: '/agencies/'
      preLoaderRoute: typeof AgenciesIndexRouteImport
      parentRoute: typeof AgenciesRoute
    }
    '/browser-live/$sessionId': {
      id: '/browser-live/$sessionId'
      path: '/$sessionId'
      fullPath: '/browser-live/$sessionId'
      preLoaderRoute: typeof BrowserLiveSessionIdLazyRouteImport
      parentRoute: typeof BrowserLiveRoute
    }
    '/workforce/$workerId': {
      id: '/workforce/$workerId'
      path: '/$workerId'
      fullPath: '/workforce/$workerId'
      preLoaderRoute: typeof WorkforceWorkerIdRouteImport
      parentRoute: typeof WorkforceRoute
    }
    '/time/workforce-plan': {
      id: '/time/workforce-plan'
      path: '/workforce-plan'
      fullPath: '/time/workforce-plan'
      preLoaderRoute: typeof TimeWorkforcePlanRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/submissions': {
      id: '/time/submissions'
      path: '/submissions'
      fullPath: '/time/submissions'
      preLoaderRoute: typeof TimeSubmissionsRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/policies': {
      id: '/time/policies'
      path: '/policies'
      fullPath: '/time/policies'
      preLoaderRoute: typeof TimePoliciesRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/off': {
      id: '/time/off'
      path: '/off'
      fullPath: '/time/off'
      preLoaderRoute: typeof TimeOffRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/my-time': {
      id: '/time/my-time'
      path: '/my-time'
      fullPath: '/time/my-time'
      preLoaderRoute: typeof TimeMyTimeRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/my-setup': {
      id: '/time/my-setup'
      path: '/my-setup'
      fullPath: '/time/my-setup'
      preLoaderRoute: typeof TimeMySetupRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/logs': {
      id: '/time/logs'
      path: '/logs'
      fullPath: '/time/logs'
      preLoaderRoute: typeof TimeLogsRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/holidays': {
      id: '/time/holidays'
      path: '/holidays'
      fullPath: '/time/holidays'
      preLoaderRoute: typeof TimeHolidaysRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/cycles': {
      id: '/time/cycles'
      path: '/cycles'
      fullPath: '/time/cycles'
      preLoaderRoute: typeof TimeCyclesRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/availability': {
      id: '/time/availability'
      path: '/availability'
      fullPath: '/time/availability'
      preLoaderRoute: typeof TimeAvailabilityRouteImport
      parentRoute: typeof TimeRoute
    }
    '/time/attendance': {
      id: '/time/attendance'
      path: '/attendance'
      fullPath: '/time/attendance'
      preLoaderRoute: typeof TimeAttendanceRouteImport
      parentRoute: typeof TimeRoute
    }
    '/settings/invite-member': {
      id: '/settings/invite-member'
      path: '/settings/invite-member'
      fullPath: '/settings/invite-member'
      preLoaderRoute: typeof SettingsInviteMemberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/branding': {
      id: '/settings/branding'
      path: '/settings/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof SettingsBrandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers/$vendorId': {
      id: '/providers/$vendorId'
      path: '/$vendorId'
      fullPath: '/providers/$vendorId'
      preLoaderRoute: typeof ProvidersVendorIdRouteImport
      parentRoute: typeof ProvidersRoute
    }
    '/proposals/new': {
      id: '/proposals/new'
      path: '/new'
      fullPath: '/proposals/new'
      preLoaderRoute: typeof ProposalsNewRouteImport
      parentRoute: typeof ProposalsRoute
    }
    '/proposals/approvals': {
      id: '/proposals/approvals'
      path: '/approvals'
      fullPath: '/proposals/approvals'
      preLoaderRoute: typeof ProposalsApprovalsRouteImport
      parentRoute: typeof ProposalsRoute
    }
    '/proposals/$proposalId': {
      id: '/proposals/$proposalId'
      path: '/$proposalId'
      fullPath: '/proposals/$proposalId'
      preLoaderRoute: typeof ProposalsProposalIdRouteImport
      parentRoute: typeof ProposalsRoute
    }
    '/people/new': {
      id: '/people/new'
      path: '/people/new'
      fullPath: '/people/new'
      preLoaderRoute: typeof PeopleNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$personId': {
      id: '/people/$personId'
      path: '/people/$personId'
      fullPath: '/people/$personId'
      preLoaderRoute: typeof PeoplePersonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ownership/structure': {
      id: '/ownership/structure'
      path: '/ownership/structure'
      fullPath: '/ownership/structure'
      preLoaderRoute: typeof OwnershipStructureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/worker': {
      id: '/onboarding/worker'
      path: '/onboarding/worker'
      fullPath: '/onboarding/worker'
      preLoaderRoute: typeof OnboardingWorkerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/vendor': {
      id: '/onboarding/vendor'
      path: '/onboarding/vendor'
      fullPath: '/onboarding/vendor'
      preLoaderRoute: typeof OnboardingVendorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/eor-aor': {
      id: '/onboarding/eor-aor'
      path: '/onboarding/eor-aor'
      fullPath: '/onboarding/eor-aor'
      preLoaderRoute: typeof OnboardingEorAorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/client': {
      id: '/onboarding/client'
      path: '/onboarding/client'
      fullPath: '/onboarding/client'
      preLoaderRoute: typeof OnboardingClientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/agency': {
      id: '/onboarding/agency'
      path: '/onboarding/agency'
      fullPath: '/onboarding/agency'
      preLoaderRoute: typeof OnboardingAgencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices/tax-rules': {
      id: '/invoices/tax-rules'
      path: '/tax-rules'
      fullPath: '/invoices/tax-rules'
      preLoaderRoute: typeof InvoicesTaxRulesRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/invoices/service-catalogue': {
      id: '/invoices/service-catalogue'
      path: '/service-catalogue'
      fullPath: '/invoices/service-catalogue'
      preLoaderRoute: typeof InvoicesServiceCatalogueRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/invoices/new': {
      id: '/invoices/new'
      path: '/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof InvoicesNewRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/invoices/dues': {
      id: '/invoices/dues'
      path: '/dues'
      fullPath: '/invoices/dues'
      preLoaderRoute: typeof InvoicesDuesRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/invoices/custom-fields': {
      id: '/invoices/custom-fields'
      path: '/custom-fields'
      fullPath: '/invoices/custom-fields'
      preLoaderRoute: typeof InvoicesCustomFieldsRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/invoices/categories': {
      id: '/invoices/categories'
      path: '/categories'
      fullPath: '/invoices/categories'
      preLoaderRoute: typeof InvoicesCategoriesRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/invoices/$invoiceId': {
      id: '/invoices/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof InvoicesInvoiceIdRouteImport
      parentRoute: typeof InvoicesRoute
    }
    '/integrations/books': {
      id: '/integrations/books'
      path: '/books'
      fullPath: '/integrations/books'
      preLoaderRoute: typeof IntegrationsBooksRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/forms/library': {
      id: '/forms/library'
      path: '/forms/library'
      fullPath: '/forms/library'
      preLoaderRoute: typeof FormsLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/admin': {
      id: '/forms/admin'
      path: '/forms/admin'
      fullPath: '/forms/admin'
      preLoaderRoute: typeof FormsAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities/new': {
      id: '/entities/new'
      path: '/new'
      fullPath: '/entities/new'
      preLoaderRoute: typeof EntitiesNewRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/entities/bulk-import': {
      id: '/entities/bulk-import'
      path: '/bulk-import'
      fullPath: '/entities/bulk-import'
      preLoaderRoute: typeof EntitiesBulkImportRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/entities/$entityId': {
      id: '/entities/$entityId'
      path: '/$entityId'
      fullPath: '/entities/$entityId'
      preLoaderRoute: typeof EntitiesEntityIdRouteImport
      parentRoute: typeof EntitiesRoute
    }
    '/engagements/new': {
      id: '/engagements/new'
      path: '/new'
      fullPath: '/engagements/new'
      preLoaderRoute: typeof EngagementsNewRouteImport
      parentRoute: typeof EngagementsRoute
    }
    '/engagements/$engagementId': {
      id: '/engagements/$engagementId'
      path: '/$engagementId'
      fullPath: '/engagements/$engagementId'
      preLoaderRoute: typeof EngagementsEngagementIdRouteImport
      parentRoute: typeof EngagementsRoute
    }
    '/documents/uploaded': {
      id: '/documents/uploaded'
      path: '/uploaded'
      fullPath: '/documents/uploaded'
      preLoaderRoute: typeof DocumentsUploadedRouteImport
      parentRoute: typeof DocumentsRoute
    }
    '/documents/$instanceId': {
      id: '/documents/$instanceId'
      path: '/$instanceId'
      fullPath: '/documents/$instanceId'
      preLoaderRoute: typeof DocumentsInstanceIdRouteImport
      parentRoute: typeof DocumentsRoute
    }
    '/crm/settings': {
      id: '/crm/settings'
      path: '/settings'
      fullPath: '/crm/settings'
      preLoaderRoute: typeof CrmSettingsRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/proposals': {
      id: '/crm/proposals'
      path: '/proposals'
      fullPath: '/crm/proposals'
      preLoaderRoute: typeof CrmProposalsRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/opportunities': {
      id: '/crm/opportunities'
      path: '/opportunities'
      fullPath: '/crm/opportunities'
      preLoaderRoute: typeof CrmOpportunitiesRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/my-work': {
      id: '/crm/my-work'
      path: '/my-work'
      fullPath: '/crm/my-work'
      preLoaderRoute: typeof CrmMyWorkRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/leads': {
      id: '/crm/leads'
      path: '/leads'
      fullPath: '/crm/leads'
      preLoaderRoute: typeof CrmLeadsRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/handover': {
      id: '/crm/handover'
      path: '/handover'
      fullPath: '/crm/handover'
      preLoaderRoute: typeof CrmHandoverRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/contacts': {
      id: '/crm/contacts'
      path: '/contacts'
      fullPath: '/crm/contacts'
      preLoaderRoute: typeof CrmContactsRouteImport
      parentRoute: typeof CrmRoute
    }
    '/crm/catalog': {
      id: '/crm/catalog'
      path: '/catalog'
      fullPath: '/crm/catalog'
      preLoaderRoute: typeof CrmCatalogRouteImport
      parentRoute: typeof CrmRoute
    }
    '/compliance/calendar': {
      id: '/compliance/calendar'
      path: '/compliance/calendar'
      fullPath: '/compliance/calendar'
      preLoaderRoute: typeof ComplianceCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof ClientsRoute
    }
    '/ask/$conversationId': {
      id: '/ask/$conversationId'
      path: '/ask/$conversationId'
      fullPath: '/ask/$conversationId'
      preLoaderRoute: typeof AskConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agreements/$agreementId': {
      id: '/agreements/$agreementId'
      path: '/agreements/$agreementId'
      fullPath: '/agreements/$agreementId'
      preLoaderRoute: typeof AgreementsAgreementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent/$sessionId': {
      id: '/agent/$sessionId'
      path: '/$sessionId'
      fullPath: '/agent/$sessionId'
      preLoaderRoute: typeof AgentSessionIdRouteImport
      parentRoute: typeof AgentRoute
    }
    '/agency/pending': {
      id: '/agency/pending'
      path: '/agency/pending'
      fullPath: '/agency/pending'
      preLoaderRoute: typeof AgencyPendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agencies/$agencyId': {
      id: '/agencies/$agencyId'
      path: '/$agencyId'
      fullPath: '/agencies/$agencyId'
      preLoaderRoute: typeof AgenciesAgencyIdRouteImport
      parentRoute: typeof AgenciesRoute
    }
    '/time/off/': {
      id: '/time/off/'
      path: '/'
      fullPath: '/time/off/'
      preLoaderRoute: typeof TimeOffIndexRouteImport
      parentRoute: typeof TimeOffRoute
    }
    '/time/logs/': {
      id: '/time/logs/'
      path: '/'
      fullPath: '/time/logs/'
      preLoaderRoute: typeof TimeLogsIndexRouteImport
      parentRoute: typeof TimeLogsRoute
    }
    '/template-engine/templates/': {
      id: '/template-engine/templates/'
      path: '/template-engine/templates'
      fullPath: '/template-engine/templates/'
      preLoaderRoute: typeof TemplateEngineTemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/agencies/': {
      id: '/platform/agencies/'
      path: '/platform/agencies'
      fullPath: '/platform/agencies/'
      preLoaderRoute: typeof PlatformAgenciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/templates/': {
      id: '/forms/templates/'
      path: '/forms/templates'
      fullPath: '/forms/templates/'
      preLoaderRoute: typeof FormsTemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm/proposals/': {
      id: '/crm/proposals/'
      path: '/'
      fullPath: '/crm/proposals/'
      preLoaderRoute: typeof CrmProposalsIndexRouteImport
      parentRoute: typeof CrmProposalsRoute
    }
    '/ask/canvas/': {
      id: '/ask/canvas/'
      path: '/ask/canvas'
      fullPath: '/ask/canvas/'
      preLoaderRoute: typeof AskCanvasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/time/logs/$timesheetId': {
      id: '/time/logs/$timesheetId'
      path: '/$timesheetId'
      fullPath: '/time/logs/$timesheetId'
      preLoaderRoute: typeof TimeLogsTimesheetIdRouteImport
      parentRoute: typeof TimeLogsRoute
    }
    '/template-engine/templates/new': {
      id: '/template-engine/templates/new'
      path: '/template-engine/templates/new'
      fullPath: '/template-engine/templates/new'
      preLoaderRoute: typeof TemplateEngineTemplatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/template-engine/templates/$templateId': {
      id: '/template-engine/templates/$templateId'
      path: '/template-engine/templates/$templateId'
      fullPath: '/template-engine/templates/$templateId'
      preLoaderRoute: typeof TemplateEngineTemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposals/$proposalId_/review': {
      id: '/proposals/$proposalId_/review'
      path: '/$proposalId/review'
      fullPath: '/proposals/$proposalId/review'
      preLoaderRoute: typeof ProposalsProposalIdReviewRouteImport
      parentRoute: typeof ProposalsRoute
    }
    '/proposals/$proposalId_/edit': {
      id: '/proposals/$proposalId_/edit'
      path: '/$proposalId/edit'
      fullPath: '/proposals/$proposalId/edit'
      preLoaderRoute: typeof ProposalsProposalIdEditRouteImport
      parentRoute: typeof ProposalsRoute
    }
    '/integrations/providers/$providerId': {
      id: '/integrations/providers/$providerId'
      path: '/providers/$providerId'
      fullPath: '/integrations/providers/$providerId'
      preLoaderRoute: typeof IntegrationsProvidersProviderIdRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/integrations/connections/$id': {
      id: '/integrations/connections/$id'
      path: '/connections/$id'
      fullPath: '/integrations/connections/$id'
      preLoaderRoute: typeof IntegrationsConnectionsIdRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/forms/templates/new': {
      id: '/forms/templates/new'
      path: '/forms/templates/new'
      fullPath: '/forms/templates/new'
      preLoaderRoute: typeof FormsTemplatesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/templates/$templateId': {
      id: '/forms/templates/$templateId'
      path: '/forms/templates/$templateId'
      fullPath: '/forms/templates/$templateId'
      preLoaderRoute: typeof FormsTemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/admin/new': {
      id: '/forms/admin/new'
      path: '/new'
      fullPath: '/forms/admin/new'
      preLoaderRoute: typeof FormsAdminNewRouteImport
      parentRoute: typeof FormsAdminRoute
    }
    '/engagements/$engagementId_/intake': {
      id: '/engagements/$engagementId_/intake'
      path: '/$engagementId/intake'
      fullPath: '/engagements/$engagementId/intake'
      preLoaderRoute: typeof EngagementsEngagementIdIntakeRouteImport
      parentRoute: typeof EngagementsRoute
    }
    '/documents/uploaded/$documentId': {
      id: '/documents/uploaded/$documentId'
      path: '/$documentId'
      fullPath: '/documents/uploaded/$documentId'
      preLoaderRoute: typeof DocumentsUploadedDocumentIdRouteImport
      parentRoute: typeof DocumentsUploadedRoute
    }
    '/crm/proposals/new': {
      id: '/crm/proposals/new'
      path: '/new'
      fullPath: '/crm/proposals/new'
      preLoaderRoute: typeof CrmProposalsNewRouteImport
      parentRoute: typeof CrmProposalsRoute
    }
    '/crm/proposals/approvals': {
      id: '/crm/proposals/approvals'
      path: '/approvals'
      fullPath: '/crm/proposals/approvals'
      preLoaderRoute: typeof CrmProposalsApprovalsRouteImport
      parentRoute: typeof CrmProposalsRoute
    }
    '/crm/proposals/$proposalId': {
      id: '/crm/proposals/$proposalId'
      path: '/$proposalId'
      fullPath: '/crm/proposals/$proposalId'
      preLoaderRoute: typeof CrmProposalsProposalIdRouteImport
      parentRoute: typeof CrmProposalsRoute
    }
    '/integrations/providers/$providerId/discovery': {
      id: '/integrations/providers/$providerId/discovery'
      path: '/discovery'
      fullPath: '/integrations/providers/$providerId/discovery'
      preLoaderRoute: typeof IntegrationsProvidersProviderIdDiscoveryRouteImport
      parentRoute: typeof IntegrationsProvidersProviderIdRoute
    }
    '/integrations/connections/$id/mappings': {
      id: '/integrations/connections/$id/mappings'
      path: '/mappings'
      fullPath: '/integrations/connections/$id/mappings'
      preLoaderRoute: typeof IntegrationsConnectionsIdMappingsRouteImport
      parentRoute: typeof IntegrationsConnectionsIdRoute
    }
    '/crm/proposals/$proposalId_/review': {
      id: '/crm/proposals/$proposalId_/review'
      path: '/$proposalId/review'
      fullPath: '/crm/proposals/$proposalId/review'
      preLoaderRoute: typeof CrmProposalsProposalIdReviewRouteImport
      parentRoute: typeof CrmProposalsRoute
    }
    '/crm/proposals/$proposalId_/edit': {
      id: '/crm/proposals/$proposalId_/edit'
      path: '/$proposalId/edit'
      fullPath: '/crm/proposals/$proposalId/edit'
      preLoaderRoute: typeof CrmProposalsProposalIdEditRouteImport
      parentRoute: typeof CrmProposalsRoute
    }
  }
}

interface AgenciesRouteChildren {
  AgenciesAgencyIdRoute: typeof AgenciesAgencyIdRoute
  AgenciesIndexRoute: typeof AgenciesIndexRoute
}

const AgenciesRouteChildren: AgenciesRouteChildren = {
  AgenciesAgencyIdRoute: AgenciesAgencyIdRoute,
  AgenciesIndexRoute: AgenciesIndexRoute,
}

const AgenciesRouteWithChildren = AgenciesRoute._addFileChildren(
  AgenciesRouteChildren,
)

interface AgentRouteChildren {
  AgentSessionIdRoute: typeof AgentSessionIdRoute
}

const AgentRouteChildren: AgentRouteChildren = {
  AgentSessionIdRoute: AgentSessionIdRoute,
}

const AgentRouteWithChildren = AgentRoute._addFileChildren(AgentRouteChildren)

interface BrowserLiveRouteChildren {
  BrowserLiveSessionIdLazyRoute: typeof BrowserLiveSessionIdLazyRoute
}

const BrowserLiveRouteChildren: BrowserLiveRouteChildren = {
  BrowserLiveSessionIdLazyRoute: BrowserLiveSessionIdLazyRoute,
}

const BrowserLiveRouteWithChildren = BrowserLiveRoute._addFileChildren(
  BrowserLiveRouteChildren,
)

interface ClientsRouteChildren {
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
}

const ClientsRouteChildren: ClientsRouteChildren = {
  ClientsClientIdRoute: ClientsClientIdRoute,
  ClientsIndexRoute: ClientsIndexRoute,
}

const ClientsRouteWithChildren =
  ClientsRoute._addFileChildren(ClientsRouteChildren)

interface CrmProposalsRouteChildren {
  CrmProposalsProposalIdRoute: typeof CrmProposalsProposalIdRoute
  CrmProposalsApprovalsRoute: typeof CrmProposalsApprovalsRoute
  CrmProposalsNewRoute: typeof CrmProposalsNewRoute
  CrmProposalsIndexRoute: typeof CrmProposalsIndexRoute
  CrmProposalsProposalIdEditRoute: typeof CrmProposalsProposalIdEditRoute
  CrmProposalsProposalIdReviewRoute: typeof CrmProposalsProposalIdReviewRoute
}

const CrmProposalsRouteChildren: CrmProposalsRouteChildren = {
  CrmProposalsProposalIdRoute: CrmProposalsProposalIdRoute,
  CrmProposalsApprovalsRoute: CrmProposalsApprovalsRoute,
  CrmProposalsNewRoute: CrmProposalsNewRoute,
  CrmProposalsIndexRoute: CrmProposalsIndexRoute,
  CrmProposalsProposalIdEditRoute: CrmProposalsProposalIdEditRoute,
  CrmProposalsProposalIdReviewRoute: CrmProposalsProposalIdReviewRoute,
}

const CrmProposalsRouteWithChildren = CrmProposalsRoute._addFileChildren(
  CrmProposalsRouteChildren,
)

interface CrmRouteChildren {
  CrmCatalogRoute: typeof CrmCatalogRoute
  CrmContactsRoute: typeof CrmContactsRoute
  CrmHandoverRoute: typeof CrmHandoverRoute
  CrmLeadsRoute: typeof CrmLeadsRoute
  CrmMyWorkRoute: typeof CrmMyWorkRoute
  CrmOpportunitiesRoute: typeof CrmOpportunitiesRoute
  CrmProposalsRoute: typeof CrmProposalsRouteWithChildren
  CrmSettingsRoute: typeof CrmSettingsRoute
  CrmIndexRoute: typeof CrmIndexRoute
}

const CrmRouteChildren: CrmRouteChildren = {
  CrmCatalogRoute: CrmCatalogRoute,
  CrmContactsRoute: CrmContactsRoute,
  CrmHandoverRoute: CrmHandoverRoute,
  CrmLeadsRoute: CrmLeadsRoute,
  CrmMyWorkRoute: CrmMyWorkRoute,
  CrmOpportunitiesRoute: CrmOpportunitiesRoute,
  CrmProposalsRoute: CrmProposalsRouteWithChildren,
  CrmSettingsRoute: CrmSettingsRoute,
  CrmIndexRoute: CrmIndexRoute,
}

const CrmRouteWithChildren = CrmRoute._addFileChildren(CrmRouteChildren)

interface DocumentsUploadedRouteChildren {
  DocumentsUploadedDocumentIdRoute: typeof DocumentsUploadedDocumentIdRoute
}

const DocumentsUploadedRouteChildren: DocumentsUploadedRouteChildren = {
  DocumentsUploadedDocumentIdRoute: DocumentsUploadedDocumentIdRoute,
}

const DocumentsUploadedRouteWithChildren =
  DocumentsUploadedRoute._addFileChildren(DocumentsUploadedRouteChildren)

interface DocumentsRouteChildren {
  DocumentsInstanceIdRoute: typeof DocumentsInstanceIdRoute
  DocumentsUploadedRoute: typeof DocumentsUploadedRouteWithChildren
  DocumentsIndexRoute: typeof DocumentsIndexRoute
}

const DocumentsRouteChildren: DocumentsRouteChildren = {
  DocumentsInstanceIdRoute: DocumentsInstanceIdRoute,
  DocumentsUploadedRoute: DocumentsUploadedRouteWithChildren,
  DocumentsIndexRoute: DocumentsIndexRoute,
}

const DocumentsRouteWithChildren = DocumentsRoute._addFileChildren(
  DocumentsRouteChildren,
)

interface EngagementsRouteChildren {
  EngagementsEngagementIdRoute: typeof EngagementsEngagementIdRoute
  EngagementsNewRoute: typeof EngagementsNewRoute
  EngagementsIndexRoute: typeof EngagementsIndexRoute
  EngagementsEngagementIdIntakeRoute: typeof EngagementsEngagementIdIntakeRoute
}

const EngagementsRouteChildren: EngagementsRouteChildren = {
  EngagementsEngagementIdRoute: EngagementsEngagementIdRoute,
  EngagementsNewRoute: EngagementsNewRoute,
  EngagementsIndexRoute: EngagementsIndexRoute,
  EngagementsEngagementIdIntakeRoute: EngagementsEngagementIdIntakeRoute,
}

const EngagementsRouteWithChildren = EngagementsRoute._addFileChildren(
  EngagementsRouteChildren,
)

interface EntitiesRouteChildren {
  EntitiesEntityIdRoute: typeof EntitiesEntityIdRoute
  EntitiesBulkImportRoute: typeof EntitiesBulkImportRoute
  EntitiesNewRoute: typeof EntitiesNewRoute
  EntitiesIndexRoute: typeof EntitiesIndexRoute
}

const EntitiesRouteChildren: EntitiesRouteChildren = {
  EntitiesEntityIdRoute: EntitiesEntityIdRoute,
  EntitiesBulkImportRoute: EntitiesBulkImportRoute,
  EntitiesNewRoute: EntitiesNewRoute,
  EntitiesIndexRoute: EntitiesIndexRoute,
}

const EntitiesRouteWithChildren = EntitiesRoute._addFileChildren(
  EntitiesRouteChildren,
)

interface IntegrationsConnectionsIdRouteChildren {
  IntegrationsConnectionsIdMappingsRoute: typeof IntegrationsConnectionsIdMappingsRoute
}

const IntegrationsConnectionsIdRouteChildren: IntegrationsConnectionsIdRouteChildren =
  {
    IntegrationsConnectionsIdMappingsRoute:
      IntegrationsConnectionsIdMappingsRoute,
  }

const IntegrationsConnectionsIdRouteWithChildren =
  IntegrationsConnectionsIdRoute._addFileChildren(
    IntegrationsConnectionsIdRouteChildren,
  )

interface IntegrationsProvidersProviderIdRouteChildren {
  IntegrationsProvidersProviderIdDiscoveryRoute: typeof IntegrationsProvidersProviderIdDiscoveryRoute
}

const IntegrationsProvidersProviderIdRouteChildren: IntegrationsProvidersProviderIdRouteChildren =
  {
    IntegrationsProvidersProviderIdDiscoveryRoute:
      IntegrationsProvidersProviderIdDiscoveryRoute,
  }

const IntegrationsProvidersProviderIdRouteWithChildren =
  IntegrationsProvidersProviderIdRoute._addFileChildren(
    IntegrationsProvidersProviderIdRouteChildren,
  )

interface IntegrationsRouteChildren {
  IntegrationsBooksRoute: typeof IntegrationsBooksRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
  IntegrationsConnectionsIdRoute: typeof IntegrationsConnectionsIdRouteWithChildren
  IntegrationsProvidersProviderIdRoute: typeof IntegrationsProvidersProviderIdRouteWithChildren
}

const IntegrationsRouteChildren: IntegrationsRouteChildren = {
  IntegrationsBooksRoute: IntegrationsBooksRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
  IntegrationsConnectionsIdRoute: IntegrationsConnectionsIdRouteWithChildren,
  IntegrationsProvidersProviderIdRoute:
    IntegrationsProvidersProviderIdRouteWithChildren,
}

const IntegrationsRouteWithChildren = IntegrationsRoute._addFileChildren(
  IntegrationsRouteChildren,
)

interface InvoicesRouteChildren {
  InvoicesInvoiceIdRoute: typeof InvoicesInvoiceIdRoute
  InvoicesCategoriesRoute: typeof InvoicesCategoriesRoute
  InvoicesCustomFieldsRoute: typeof InvoicesCustomFieldsRoute
  InvoicesDuesRoute: typeof InvoicesDuesRoute
  InvoicesNewRoute: typeof InvoicesNewRoute
  InvoicesServiceCatalogueRoute: typeof InvoicesServiceCatalogueRoute
  InvoicesTaxRulesRoute: typeof InvoicesTaxRulesRoute
  InvoicesIndexRoute: typeof InvoicesIndexRoute
}

const InvoicesRouteChildren: InvoicesRouteChildren = {
  InvoicesInvoiceIdRoute: InvoicesInvoiceIdRoute,
  InvoicesCategoriesRoute: InvoicesCategoriesRoute,
  InvoicesCustomFieldsRoute: InvoicesCustomFieldsRoute,
  InvoicesDuesRoute: InvoicesDuesRoute,
  InvoicesNewRoute: InvoicesNewRoute,
  InvoicesServiceCatalogueRoute: InvoicesServiceCatalogueRoute,
  InvoicesTaxRulesRoute: InvoicesTaxRulesRoute,
  InvoicesIndexRoute: InvoicesIndexRoute,
}

const InvoicesRouteWithChildren = InvoicesRoute._addFileChildren(
  InvoicesRouteChildren,
)

interface ProposalsRouteChildren {
  ProposalsProposalIdRoute: typeof ProposalsProposalIdRoute
  ProposalsApprovalsRoute: typeof ProposalsApprovalsRoute
  ProposalsNewRoute: typeof ProposalsNewRoute
  ProposalsIndexRoute: typeof ProposalsIndexRoute
  ProposalsProposalIdEditRoute: typeof ProposalsProposalIdEditRoute
  ProposalsProposalIdReviewRoute: typeof ProposalsProposalIdReviewRoute
}

const ProposalsRouteChildren: ProposalsRouteChildren = {
  ProposalsProposalIdRoute: ProposalsProposalIdRoute,
  ProposalsApprovalsRoute: ProposalsApprovalsRoute,
  ProposalsNewRoute: ProposalsNewRoute,
  ProposalsIndexRoute: ProposalsIndexRoute,
  ProposalsProposalIdEditRoute: ProposalsProposalIdEditRoute,
  ProposalsProposalIdReviewRoute: ProposalsProposalIdReviewRoute,
}

const ProposalsRouteWithChildren = ProposalsRoute._addFileChildren(
  ProposalsRouteChildren,
)

interface ProvidersRouteChildren {
  ProvidersVendorIdRoute: typeof ProvidersVendorIdRoute
  ProvidersIndexRoute: typeof ProvidersIndexRoute
}

const ProvidersRouteChildren: ProvidersRouteChildren = {
  ProvidersVendorIdRoute: ProvidersVendorIdRoute,
  ProvidersIndexRoute: ProvidersIndexRoute,
}

const ProvidersRouteWithChildren = ProvidersRoute._addFileChildren(
  ProvidersRouteChildren,
)

interface TimeLogsRouteChildren {
  TimeLogsTimesheetIdRoute: typeof TimeLogsTimesheetIdRoute
  TimeLogsIndexRoute: typeof TimeLogsIndexRoute
}

const TimeLogsRouteChildren: TimeLogsRouteChildren = {
  TimeLogsTimesheetIdRoute: TimeLogsTimesheetIdRoute,
  TimeLogsIndexRoute: TimeLogsIndexRoute,
}

const TimeLogsRouteWithChildren = TimeLogsRoute._addFileChildren(
  TimeLogsRouteChildren,
)

interface TimeOffRouteChildren {
  TimeOffIndexRoute: typeof TimeOffIndexRoute
}

const TimeOffRouteChildren: TimeOffRouteChildren = {
  TimeOffIndexRoute: TimeOffIndexRoute,
}

const TimeOffRouteWithChildren =
  TimeOffRoute._addFileChildren(TimeOffRouteChildren)

interface TimeRouteChildren {
  TimeAttendanceRoute: typeof TimeAttendanceRoute
  TimeAvailabilityRoute: typeof TimeAvailabilityRoute
  TimeCyclesRoute: typeof TimeCyclesRoute
  TimeHolidaysRoute: typeof TimeHolidaysRoute
  TimeLogsRoute: typeof TimeLogsRouteWithChildren
  TimeMySetupRoute: typeof TimeMySetupRoute
  TimeMyTimeRoute: typeof TimeMyTimeRoute
  TimeOffRoute: typeof TimeOffRouteWithChildren
  TimePoliciesRoute: typeof TimePoliciesRoute
  TimeSubmissionsRoute: typeof TimeSubmissionsRoute
  TimeWorkforcePlanRoute: typeof TimeWorkforcePlanRoute
  TimeIndexRoute: typeof TimeIndexRoute
}

const TimeRouteChildren: TimeRouteChildren = {
  TimeAttendanceRoute: TimeAttendanceRoute,
  TimeAvailabilityRoute: TimeAvailabilityRoute,
  TimeCyclesRoute: TimeCyclesRoute,
  TimeHolidaysRoute: TimeHolidaysRoute,
  TimeLogsRoute: TimeLogsRouteWithChildren,
  TimeMySetupRoute: TimeMySetupRoute,
  TimeMyTimeRoute: TimeMyTimeRoute,
  TimeOffRoute: TimeOffRouteWithChildren,
  TimePoliciesRoute: TimePoliciesRoute,
  TimeSubmissionsRoute: TimeSubmissionsRoute,
  TimeWorkforcePlanRoute: TimeWorkforcePlanRoute,
  TimeIndexRoute: TimeIndexRoute,
}

const TimeRouteWithChildren = TimeRoute._addFileChildren(TimeRouteChildren)

interface WorkforceRouteChildren {
  WorkforceWorkerIdRoute: typeof WorkforceWorkerIdRoute
  WorkforceIndexRoute: typeof WorkforceIndexRoute
}

const WorkforceRouteChildren: WorkforceRouteChildren = {
  WorkforceWorkerIdRoute: WorkforceWorkerIdRoute,
  WorkforceIndexRoute: WorkforceIndexRoute,
}

const WorkforceRouteWithChildren = WorkforceRoute._addFileChildren(
  WorkforceRouteChildren,
)

interface FormsAdminRouteChildren {
  FormsAdminNewRoute: typeof FormsAdminNewRoute
}

const FormsAdminRouteChildren: FormsAdminRouteChildren = {
  FormsAdminNewRoute: FormsAdminNewRoute,
}

const FormsAdminRouteWithChildren = FormsAdminRoute._addFileChildren(
  FormsAdminRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgenciesRoute: AgenciesRouteWithChildren,
  AgentRoute: AgentRouteWithChildren,
  BrowserLiveRoute: BrowserLiveRouteWithChildren,
  CalendarRoute: CalendarRoute,
  ClientsRoute: ClientsRouteWithChildren,
  CrmRoute: CrmRouteWithChildren,
  DashboardRoute: DashboardRoute,
  DocumentsRoute: DocumentsRouteWithChildren,
  EngagementsRoute: EngagementsRouteWithChildren,
  EntitiesRoute: EntitiesRouteWithChildren,
  ImportCenterRoute: ImportCenterRoute,
  IntegrationsRoute: IntegrationsRouteWithChildren,
  InvoicesRoute: InvoicesRouteWithChildren,
  OrgChartRoute: OrgChartRoute,
  ProposalsRoute: ProposalsRouteWithChildren,
  ProvidersRoute: ProvidersRouteWithChildren,
  RelationshipsRoute: RelationshipsRoute,
  ReportsRoute: ReportsRoute,
  RiskRoute: RiskRoute,
  TimeRoute: TimeRouteWithChildren,
  WorkforceRoute: WorkforceRouteWithChildren,
  AgencyPendingRoute: AgencyPendingRoute,
  AgreementsAgreementIdRoute: AgreementsAgreementIdRoute,
  AskConversationIdRoute: AskConversationIdRoute,
  ComplianceCalendarRoute: ComplianceCalendarRoute,
  FormsAdminRoute: FormsAdminRouteWithChildren,
  FormsLibraryRoute: FormsLibraryRoute,
  OauthCallbackRoute: OauthCallbackRoute,
  OnboardingAgencyRoute: OnboardingAgencyRoute,
  OnboardingClientRoute: OnboardingClientRoute,
  OnboardingEorAorRoute: OnboardingEorAorRoute,
  OnboardingVendorRoute: OnboardingVendorRoute,
  OnboardingWorkerRoute: OnboardingWorkerRoute,
  OwnershipStructureRoute: OwnershipStructureRoute,
  PeoplePersonIdRoute: PeoplePersonIdRoute,
  PeopleNewRoute: PeopleNewRoute,
  SettingsBrandingRoute: SettingsBrandingRoute,
  SettingsInviteMemberRoute: SettingsInviteMemberRoute,
  AskIndexRoute: AskIndexRoute,
  ComplianceIndexRoute: ComplianceIndexRoute,
  FavouritesIndexRoute: FavouritesIndexRoute,
  FormsIndexRoute: FormsIndexRoute,
  HelpRequestsIndexRoute: HelpRequestsIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TemplateEngineIndexRoute: TemplateEngineIndexRoute,
  FormsTemplatesTemplateIdRoute: FormsTemplatesTemplateIdRoute,
  FormsTemplatesNewRoute: FormsTemplatesNewRoute,
  TemplateEngineTemplatesTemplateIdRoute:
    TemplateEngineTemplatesTemplateIdRoute,
  TemplateEngineTemplatesNewRoute: TemplateEngineTemplatesNewRoute,
  AskCanvasIndexRoute: AskCanvasIndexRoute,
  FormsTemplatesIndexRoute: FormsTemplatesIndexRoute,
  PlatformAgenciesIndexRoute: PlatformAgenciesIndexRoute,
  TemplateEngineTemplatesIndexRoute: TemplateEngineTemplatesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
